<style lang="less">
@import "../styles/base.less";
.border-light-yellow{
  border: 1px solid yellow;
  color: yellow;
}
.border-light-green{
    border: 1px solid #3CD497;
    color: #3CD497;
}
.border-red{
    border: 1px solid #FD5A5B;
    color: #FD5A5B;
}
.border-color-orange{
    border: 1px solid #FF964A;
    color: #FF964A;
}
.border-color-purple{
  border: 1px solid #0C25F1;
  color: #0C25F1;
}
.border-color-blue{
  border: 1px solid #326CFB;
  color: #326CFB;
}
.color-green{
  color: #3CD497;
}
.equipItem {
  padding: 0 20px;
  height: 32px;
  text-align: center;
  line-height: 30px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid #EEEEEE;
  border-radius: 2px;
  color: #1E1E1E;
  margin-right: 20px;
  cursor: pointer;
}

.width200 {
  width: 200px;
}

.activeItem {
  color: #FFFFFF;
  background: rgba(50, 108, 251, 1);
}

.borderDiv {
  border: 1px solid #E2E2E2;
  padding: 10px;
}

.mainHeader {
  display: flex;
  justify-content: space-between;
  height: 47px;
  line-height: 47px;
  padding: 0 1.5rem;
  background: #326CFB;
  width: 100%;
  font-family: Microsoft YaHei;
  color: #FFFFFF;

  .headerLeft {
    font-size: 26px;
  }

  .headerRight {
    font-size: 20px;
  }
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}

.ivu-message {
  z-index: 20000 !important;
}

.ivu-checkbox-checked .ivu-checkbox-inner {
  border-color: #326CFB !important;
  background-color: #326CFB !important;
}

.ivu-btn-primary {
  background-color: #326CFB !important;
  border-color: #326CFB !important;
}

.ivu-tabs-nav .ivu-tabs-tab-active {
  color: #326CFB !important;
}

.processDiv {
  display: inline-block;
  margin-right: 5px;
  margin-bottom: 5px;
}
.ivu-table-row-hover td{
background-color: #c6e8ff !important;
}
</style>
<style lang="css">
@import "../styles/iconfont/iconfont.css";
</style>
<template>
  <div>
    <div style="min-height: 800px;">


      <div class="mainHeader">
        <div class="headerLeft">
          进度管控
        </div>
        <div class="headerRight">
          登录账户：<span style="margin-right: 70px">{{ userName }}</span><span @click="exitBtn"
            style="cursor: pointer">退出</span>
        </div>

      </div>

      <div style="padding: 20px">
        <Tabs @on-click="changeTab" v-model="activeTab" :animated="false">
          <!-- <TabPane label="工序排产" name="0">

            <Row>
              <Form inline :label-width="80" class="basicForm" ref="searchForm" :model="searchForm">
                <FormItem class="form-item" label="工序">
                  <Select v-model="searchForm.processId" class="width160" placeholder="请选择" @on-change="getEquipList">
                    <Option v-for="item in processData" :value="item.id" :key="item.id" :label="item.name"></Option>
                  </Select>
                </FormItem>
                <FormItem class="form-item" label="产品类别">
                  <Select v-model="searchForm.productId" transfer clearable class="width160">
                    <Option v-for="item in productList" :value="item.productId" :key="item.id"
                      :label="item.productName"></Option>
                  </Select>
                </FormItem>
                <FormItem class="form-item" label="版号">
                  <Input class="width160" type="text" clearable v-model.trim="searchForm.pbPartNo" placeholder="请输入" />
                </FormItem>
                <FormItem class="form-item" label="宽度">
                  <Select v-model="searchForm.level" transfer clearable class="width160">
                    <Option value="">全部</Option>
                    <Option value="22">44</Option>
                    <Option value="1080">1080</Option>
                  </Select>
                </FormItem>
                <FormItem class="form-item" label="工单号">
                  <Input class="width160" type="text" clearable v-model.trim="searchForm.partNo" placeholder="请输入" />
                </FormItem>
                <FormItem class="form-item" label="订单号">
                  <Input class="width160" type="text" clearable v-model.trim="searchForm.orderNo" placeholder="请输入" />
                </FormItem>
                <FormItem class="form-item" label="优先级">
                  <Select v-model="searchForm.level" transfer clearable class="width160">
                    <Option value="">全部</Option>
                    <Option value="0">0</Option>
                    <Option value="1">1</Option>
                    <Option value="2">2</Option>
                    <Option value="3">3</Option>
                    <Option value="4">4</Option>
                    <Option value="5">5</Option>
                    <Option value="6">6</Option>
                    <Option value="7">7</Option>
                    <Option value="8">8</Option>
                    <Option value="9">9</Option>
                  </Select>
                </FormItem>


                <FormItem label="" :label-width="0">
                  <Select v-model="refreshWay" transfer clearable style="width: 130px" @on-change="selectWay">
                    <Option :value="1">自动刷新3分钟</Option>
                    <Option :value="2">自动刷新5分钟</Option>
                  </Select>
                </FormItem>
                <FormItem class="form-item form-item-button" label="" :label-width="20" style="width: 0px">
                  <Button class="iconfont" type="primary" @click="searchBtn" :loading="loading">查询({{timeNum}})</Button>
                </FormItem>

              </Form>
            </Row>
            <Row>
              <div class="equipBtn" v-for="item in equipData">
                <div class="equipItem" :class="activeEquip == item.equipId?'activeItem':''"
                  @click="changeSelect(item.equipId)">
                  {{item.equipName}} <span>({{item.count}})</span>
                </div>

              </div>
              <div>
                <Button class="iconfont marginLeft20" type="primary" @click="printDiffWorkBtn">打印工单</Button>
              </div>
            </Row>
            <Row class="marginTop20">
              <Table v-if="searchForm.processId == 1" ref="printTab" :height="tableHeight" class="table" border
                :data="tableData" :columns="tableFhColumns" :loading="loading" highlight-row stripe>
              </Table>

              <Table v-if="searchForm.processId == 3" ref="printTab" :height="tableHeight" class="table" border
                :data="tableData" :columns="tableFgColumns" :loading="loading" highlight-row stripe>
              </Table>
              <Table v-if="searchForm.processId == 2 || searchForm.processId == 4 || searchForm.processId == 5"
                ref="printTab" :height="tableHeight" class="table" border :data="tableData" :columns="tableColumns"
                :loading="loading" highlight-row stripe>
                <template slot-scope="{ row, index }" slot="processList">
                  <div v-for="(item,idx) in row.processData" class="processDiv">
                    <button v-if="item.value == 1" class="table-status border-light-green">{{item.name}}</button>
                    <button v-if="item.value == 0" class="table-status border-red"> {{item.name}}</button>
                  </div>
                </template>
</Table>
</Row>
</TabPane> -->
          <!-- <TabPane label="拼版" name="1">
            <pb-part ref="pb"></pb-part>
          </TabPane>
          <TabPane label="工序完成" name="2">
            <process-progress ref="progress"></process-progress>
          </TabPane> -->
          <TabPane :label="`复合(${numCountObj.pasteNo})`" name="0">

            <Row>
              <Form inline :label-width="110" class="basicForm" ref="searchForm" :model="searchForm">
                <!-- <FormItem class="form-item" label="工序">
                  <Select v-model="searchForm.processId" class="width160" placeholder="请选择" @on-change="getEquipList">
                    <Option v-for="item in processData" :value="item.id" :key="item.id" :label="item.name"></Option>
                  </Select>
                </FormItem>
                <FormItem class="form-item" label="产品类别">
                  <Select v-model="searchForm.productId" transfer clearable class="width160">
                    <Option v-for="item in productList" :value="item.productId" :key="item.id"
                      :label="item.productName"></Option>
                  </Select>
                </FormItem> -->
                <!-- <FormItem class="form-item" label="版号">
                  <Input class="width160" type="text" clearable v-model.trim="searchForm.pbPartNo" placeholder="请输入" />
                </FormItem> -->
                <FormItem class="form-item" label="订/工单号">
                  <Input class="width160" type="text" clearable v-model.trim="searchForm.code" placeholder="请输入" />
                </FormItem>
                <!-- <FormItem class="form-item" label="产品名称">
                  <Input class="width160" type="text" clearable v-model.trim="searchForm.name" placeholder="请输入" />
                </FormItem> -->
                <FormItem class="form-item" label="产品名称">
                  <Select v-model="searchForm.name" class="width160" filterable clearable placeholder="请选择">
                    <Option v-for="item in productList" :value="item" :key="item" :label="item"></Option>
                  </Select>
                </FormItem>
                <FormItem class="form-item" label="宽度">
                  <Input class="width160" type="text" clearable v-model.trim="searchForm.wide" placeholder="请输入" />
                </FormItem>
                <FormItem class="form-item" label="状态">
                  <Select v-model="searchForm.status" transfer clearable class="width160">
                    <Option value="0">未生产</Option>
                    <!-- <Option value="1">生产中</Option> -->
                    <Option value="2">生产完成</Option>
                  </Select>
                </FormItem>
                <FormItem class="form-item" label="机器">
                  <Select v-model="searchForm.machineName" class="width160" clearable placeholder="请选择">
                    <Option v-for="item in processData" :value="item.name" :key="item.id" :label="item.name"></Option>
                  </Select>
                </FormItem>
                <!-- <FormItem class="form-item" label="订单号">
                  <Input class="width160" type="text" clearable v-model.trim="searchForm.orderNo" placeholder="请输入" />
                </FormItem> -->
                <!-- <FormItem class="form-item" label="优先级">
                  <Select v-model="searchForm.level" transfer clearable class="width160">
                    <Option value="">全部</Option>
                    <Option value="0">0</Option>
                    <Option value="1">1</Option>
                    <Option value="2">2</Option>
                    <Option value="3">3</Option>
                    <Option value="4">4</Option>
                    <Option value="5">5</Option>
                    <Option value="6">6</Option>
                    <Option value="7">7</Option>
                    <Option value="8">8</Option>
                    <Option value="9">9</Option>
                  </Select>
                </FormItem> -->


                <!-- <FormItem label="" :label-width="0">
                  <Select v-model="refreshWay" transfer clearable style="width: 130px" @on-change="selectWay">
                    <Option :value="1">自动刷新3分钟</Option>
                    <Option :value="2">自动刷新5分钟</Option>
                  </Select>
                </FormItem> -->
                <FormItem class="form-item form-item-button" label="" :label-width="20"
                  style="width: 0px;margin-left: 20px;">
                  <Button class="iconfont" type="primary" @click="searchBtn" :loading="loading">查询</Button>
                  <!--<Button class="iconfont marginLeft20" type="primary" @click="printWorkBtn" :loading="printLoading">打印工单</Button>-->
                </FormItem>

              </Form>
            </Row>
            <!-- <Row>
              <div class="equipBtn" v-for="item in equipData">
                <div class="equipItem" :class="activeEquip == item.equipId ? 'activeItem' : ''"
                  @click="changeSelect(item.equipId)">
                  {{ item.equipName }} <span>({{ item.count }})</span>
                </div>

              </div>
              <div>
                <Button class="iconfont marginLeft20" type="primary" @click="printDiffWorkBtn">打印工单</Button>
              </div>
            </Row> -->
            <Row class="marginTop20" style="width: 100%;">
              <!-- <Table v-if="searchForm.processId == 1" ref="printTab" :height="tableHeight" class="table" border
                :data="tableData" :columns="tableFhColumns" :loading="loading" highlight-row stripe>
              </Table> -->
              <Table ref="printTab" :height="tableHeight" class="table" border :data="tableData"
                :columns="tableFhColumns" :loading="loading" highlight-row stripe>
              </Table>
              <!-- <Table v-if="searchForm.processId == 3" ref="printTab" :height="tableHeight" class="table" border
                :data="tableData" :columns="tableFgColumns" :loading="loading" highlight-row stripe>
              </Table> -->
              <!-- <Table v-if="searchForm.processId == 2 || searchForm.processId == 4 || searchForm.processId == 5"
                ref="printTab" :height="tableHeight" class="table" border :data="tableData" :columns="tableColumns"
                :loading="loading" highlight-row stripe>
                <template slot-scope="{ row, index }" slot="processList">
                  <div v-for="(item, idx) in row.processData" class="processDiv">
                    <button v-if="item.value == 1" class="table-status border-light-green">{{ item.name }}</button>
                    <button v-if="item.value == 0" class="table-status border-red"> {{ item.name }}</button>
                  </div>
                </template>
              </Table> -->
              <Row style="width:100%;display: flex;flex-direction: row; align-items: center;justify-content: center;">
                <Page :current="pageNum" :page-size="pageSize" :total="total" @on-change="handleChangePage"
                  @on-page-size-change="handlePageSizeChange" show-total show-sizer
                  style="margin-top:10px;text-align: center;" />
              </Row>
            </Row>
          </TabPane>
          <TabPane :label="`拼版(${numCountObj.makeupNo})`" name="1">
            <pb-part ref="pb"></pb-part>
          </TabPane>
          <TabPane :label="`分割(${numCountObj.splitsNo})`" name="2">

            <Row>
              <Form inline :label-width="110" class="basicForm" ref="searchFormSplit" :model="searchFormSplit">

                <FormItem class="form-item" label="订/工单号">
                  <Input class="width160" type="text" clearable v-model.trim="searchFormSplit.code" placeholder="请输入" />
                </FormItem>
                <FormItem class="form-item" label="客户名称">
            <Select v-model="searchFormSplit.customer" class="width160" clearable filterable placeholder="请选择">
                    <Option v-for="item in customerList" :value="item" :key="item" :label="item"></Option>
                  </Select>
          </FormItem>
                <FormItem class="form-item" label="产品名称">
                  <Select v-model="searchFormSplit.name" class="width160" filterable clearable placeholder="请选择">
                    <Option v-for="item in productList" :value="item" :key="item" :label="item"></Option>
                  </Select>
                </FormItem>
                <!-- <FormItem class="form-item" label="宽度">
                  <Input class="width160" type="text" clearable v-model.trim="searchFormSplit.wide" placeholder="请输入" />
                </FormItem> -->
                <FormItem class="form-item" label="状态">
                  <Select v-model="searchFormSplit.status" transfer clearable class="width160">
                    <Option value="0">未分割</Option>
                    <!-- <Option value="1">分割中</Option> -->
                    <Option value="2">分割完成</Option>
                  </Select>
                </FormItem>
                <FormItem class="form-item" label="机器">
                  <Select v-model="searchFormSplit.machineName" class="width160" clearable placeholder="请选择">
                    <Option v-for="item in processData" :value="item.name" :key="item.id" :label="item.name"></Option>
                  </Select>
                </FormItem>

                <FormItem class="form-item form-item-button" label="" :label-width="20"
                  style="width: 0px;margin-left: 20px;">
                  <Button class="iconfont" type="primary" @click="searchBtnSplit" :loading="loadingSplit">查询</Button>
                </FormItem>
              </Form>
            </Row>

            <Row class="marginTop20" style="width: 100%;">

              <Table ref="printTab" :height="tableHeight" class="table" border :data="tableDataSplit"
                :columns="tableFhColumnsSplit" :loading="loadingSplit" highlight-row stripe>
              </Table>
              <Row style="width:100%;display: flex;flex-direction: row; align-items: center;justify-content: center;">
                <Page :current="pageNumSplit" :page-size="pageSizeSplit" :total="totalSplit" @on-change="handleChangePageSplit"
                  @on-page-size-change="handlePageSizeChangeSplit" show-total show-sizer
                  style="margin-top:10px;text-align: center;" />
              </Row>
            </Row>
          </TabPane>
          <TabPane :label="`裁切(${numCountObj.sliceNo})`" name="3">

            <Row>
              <Form inline :label-width="110" class="basicForm" ref="searchFormSlice" :model="searchFormSlice">

                <FormItem class="form-item" label="订/工单号">
                  <Input class="width160" type="text" clearable v-model.trim="searchFormSlice.code" placeholder="请输入" />
                </FormItem>
                <!-- <FormItem class="form-item" label="产品名称">
                  <Input class="width160" type="text" clearable v-model.trim="searchFormSlice.name" placeholder="请输入" />
                </FormItem> -->
                <FormItem class="form-item" label="客户名称">
            <Select v-model="searchFormSlice.customer" class="width160" clearable filterable placeholder="请选择">
                    <Option v-for="item in customerList" :value="item" :key="item" :label="item"></Option>
                  </Select>
          </FormItem>
                <FormItem class="form-item" label="产品名称">
                  <Select v-model="searchFormSlice.name" class="width160" filterable clearable placeholder="请选择">
                    <Option v-for="item in productList" :value="item" :key="item" :label="item"></Option>
                  </Select>
                </FormItem>
                <!-- <FormItem class="form-item" label="宽度">
                  <Input class="width160" type="text" clearable v-model.trim="searchFormSlice.wide" placeholder="请输入" />
                </FormItem> -->
                <FormItem class="form-item" label="状态">
                  <Select v-model="searchFormSlice.status" transfer clearable class="width160">
                    <Option value="0">未裁切</Option>
                    <!-- <Option value="1">裁切中</Option> -->
                    <Option value="2">裁切完成</Option>
                  </Select>
                </FormItem>
                <FormItem class="form-item" label="机器">
                  <Select v-model="searchFormSlice.machineName" class="width160" clearable placeholder="请选择">
                    <Option v-for="item in processData" :value="item.name" :key="item.id" :label="item.name"></Option>
                  </Select>
                </FormItem>

                <FormItem class="form-item form-item-button" label="" :label-width="20"
                  style="width: 0px;margin-left: 20px;">
                  <Button class="iconfont" type="primary" @click="searchBtnSlice" :loading="loadingSlice">查询</Button>
                </FormItem>
              </Form>
            </Row>

            <Row class="marginTop20" style="width: 100%;">

              <Table ref="printTab" :height="tableHeight" class="table" border :data="tableDataSlice"
                :columns="tableFhColumnsSlice" :loading="loadingSlice" highlight-row stripe>
              </Table>
              <Row style="width:100%;display: flex;flex-direction: row; align-items: center;justify-content: center;">
                <Page :current="pageNumSlice" :page-size="pageSizeSlice" :total="totalSlice" @on-change="handleChangePageSlice"
                  @on-page-size-change="handlePageSizeChangeSlice" show-total show-sizer
                  style="margin-top:10px;text-align: center;" />
              </Row>
            </Row>
            </TabPane>
            <TabPane :label="`打包(${numCountObj.packageNo})`" name="4">

            <Row>
              <Form inline :label-width="110" class="basicForm" ref="searchFormPackAge" :model="searchFormPackAge">

                <FormItem class="form-item" label="订/工单号">
                  <Input class="width160" type="text" clearable v-model.trim="searchFormPackAge.code" placeholder="请输入" />
                </FormItem>
                <FormItem class="form-item" label="公司名称">
                  <Input class="width160" type="text" clearable v-model.trim="searchFormPackAge.customer" placeholder="请输入" />
                </FormItem>
                <!-- <FormItem class="form-item" label="物料名称">
                  <Input class="width160" type="text" clearable v-model.trim="searchFormPackAge.name" placeholder="请输入" />
                </FormItem> -->
                <FormItem class="form-item" label="产品名称">
                  <Select v-model="searchFormPackAge.name" class="width160" filterable clearable placeholder="请选择">
                    <Option v-for="item in productList" :value="item" :key="item" :label="item"></Option>
                  </Select>
                </FormItem>
                <!-- <FormItem class="form-item" label="宽度">
                  <Input class="width160" type="text" clearable v-model.trim="searchFormSlice.wide" placeholder="请输入" />
                </FormItem> -->
                <FormItem class="form-item" label="单位">
                  <Select v-model="searchFormPackAge.unit" transfer clearable class="width160">
                    <Option value="卷">卷</Option>
                    <Option value="张">张</Option>
                  </Select>
                </FormItem>
                <FormItem class="form-item" label="状态">
                  <Select v-model="searchFormPackAge.status" transfer clearable class="width160">
                    <Option value="0">未打包</Option>
                    <Option value="2">打包完成</Option>
                  </Select>
                </FormItem>
                <!-- <FormItem class="form-item" label="机器">
                  <Select v-model="searchFormSlice.processId" class="width160" clearable placeholder="请选择">
                    <Option v-for="item in processData" :value="item.id" :key="item.id" :label="item.name"></Option>
                  </Select>
                </FormItem> -->

                <FormItem class="form-item form-item-button" label="" :label-width="20"
                  style="width: 0px;margin-left: 20px;">
                  <Button class="iconfont" type="primary" @click="searchBtnPackAge" :loading="loadingPackAge">查询</Button>
                </FormItem>
              </Form>
            </Row>

            <Row class="marginTop20" style="width: 100%;">

              <Table ref="packAgeTab"@on-expand="onExpand2" :height="tableHeight" class="table" border :data="tableDataPackAge"
                :columns="tableFhColumnsPackAge" :loading="loadingPackAge" highlight-row stripe>
              </Table>
              <Row style="width:100%;display: flex;flex-direction: row; align-items: center;justify-content: center;">
                <Page :current="pageNumPackAge" :page-size="pageSizePackAge" :total="totalPackAge" @on-change="handleChangePagePackAge"
                  @on-page-size-change="handlePageSizeChangePackAge" show-total show-sizer
                  style="margin-top:10px;text-align: center;" />
              </Row>
            </Row>
            </TabPane>
        </Tabs>
      </div>

    </div>
    <Modal title="一级半成品复合" v-model="reuniteModalFlag" width="1100" footer-hide>
      <Form inline :label-width="110" class="basicForm" ref="proForm">
        <FormItem class="form-item" label="产品名称">
          <Input class="width160" type="text" readonly v-model.trim="partNoDetail.productName" placeholder="请输入..." />
        </FormItem>
        <FormItem v-if="partNoDetail.pbWidth" class="form-item" label="宽度(mm)" style="margin-left: 20px;">
          <Input class="width160" type="text" readonly v-model.trim="partNoDetail.pbWidth" placeholder="请输入..." />
        </FormItem>
        <FormItem v-if="partNoDetail.pbLength" class="form-item" label="长度(m)" style="margin-left: 20px;">
          <Input class="width160" type="text" readonly v-model.trim="partNoDetail.pbLength" placeholder="请输入..." />
        </FormItem>
        <FormItem class="form-item" label="工单数量(m2)" style="margin-left: 20px">
          <Input class="width160" type="number" readonly v-model.trim="partNoDetail.area" placeholder="请输入..." />
        </FormItem>
        <FormItem class="form-item" label="备注" style="margin-left: 20px">
          <Input class="width160" type="text" readonly v-model.trim="partNoDetail.customerRemark"
            placeholder="请输入..." />
        </FormItem>
      </Form>

      <div class="borderDiv ">
        底纸
        <Button type="primary" size="small" style="float: right;margin-top: -5px" @click="addBtn('1')">添加</Button>
        <Table class="table" border :data="backPaperData" :columns="backPaperColumns">

          <template slot-scope="{ row,index }" slot="goodsName">
            <span v-if="row.dataType == 1">{{ row.goodsName }}</span>
            <Select v-else v-model="row.goodsName" transfer @on-change="selectName(row, index)" placeholder="请选择">
              <Option v-for="item in backPaperGoodsNameList" :value="item" :key="item" :label="item"></Option>
            </Select>
          </template>

          <template slot-scope="{ row,index }" slot="goodsNo">
            <span v-if="row.dataType == 1">{{ row.goodsNo }} {{ row.specification }} </span>
            <Select v-else v-model="row.goodsNo" transfer @on-change="selectRow(row, index)" placeholder="请选择">
              <Option v-for="item in row.backPaperGoodsNoData" :value="item.goodsNo" :key="item.goodsNo"
                :label="item.goodsNo + (item.brand ? '+' + item.brand : '') + (item.specification ? '+' + item.specification : '') + (item.kweight ? '+' + item.kweight : '')">
              </Option>
            </Select>
          </template>

          <template slot-scope="{ row,index }" slot="remainWeight">
            <Input type="number" v-model.trim="row.remainWeight" clearable placeholder="请输入"
              @on-change="changeRow(row, index)" />
          </template>
          <template slot-scope="{ row,index }" slot="weightLoss">
            <Input type="number" v-model.trim="row.weightLoss" clearable placeholder="请输入"
              @on-change="changeRow(row, index)" />
          </template>
        </Table>
      </div>

      <div class="borderDiv marginTop10">
        面纸
        <Button type="primary" size="small" style="float: right;margin-top: -5px" @click="addBtn('2')">添加</Button>
        <Table class="table" border :data="facialData" :columns="facialColumns">

          <template slot-scope="{ row,index }" slot="goodsName">

            <span v-if="row.dataType == 1">{{ row.goodsName }}</span>

            <Select v-else v-model="row.goodsName" transfer @on-change="selectName2(row, index)" placeholder="请选择">
              <Option v-for="item in facialGoodsNameList" :value="item" :key="item" :label="item"></Option>
            </Select>
          </template>
          <template slot-scope="{ row,index }" slot="goodsNo">
            <span v-if="row.dataType == 1">{{ row.goodsNo }}</span>
            <Select v-else v-model="row.goodsNo" transfer @on-change="selectRow2(row, index)" placeholder="请选择">
              <Option v-for="item in row.facialGoodsNoData" :value="item.goodsNo" :key="item.goodsNo"
                :label="item.goodsNo + (item.brand ? '+' + item.brand : '') + (item.specification ? '+' + item.specification : '') + (item.kweight ? '+' + item.kweight : '')">
              </Option>
            </Select>
          </template>

          <template slot-scope="{ row,index }" slot="remainWeight">
            <Input type="number" v-model.trim="row.remainWeight" clearable placeholder="请输入"
              @on-change="changeRow2(row, index)" />
          </template>
          <template slot-scope="{ row,index }" slot="weightLoss">
            <Input type="number" v-model.trim="row.weightLoss" clearable placeholder="请输入"
              @on-change="changeRow2(row, index)" />
          </template>

        </Table>
      </div>


      <div class="borderDiv marginTop10">
        胶
        <Button type="primary" size="small" style="float: right;margin-top: -5px" @click="addBtn('3')">添加</Button>
        <Table class="table" border :data="glueData" :columns="glueColumns">

          <template slot-scope="{ row,index }" slot="goodsName">
            <span v-if="row.dataType == 1">{{ row.goodsName }}</span>
            <Select v-else v-model="row.goodsName" transfer @on-change="selectName3(row, index)" placeholder="请选择">
              <Option v-for="item in glueGoodsNameList" :value="item" :key="item" :label="item"></Option>
            </Select>
          </template>
          <template slot-scope="{ row,index }" slot="goodsNo">
            <span v-if="row.dataType == 1">{{ row.goodsNo }}</span>
            <Select v-else v-model="row.goodsNo" transfer @on-change="selectRow3(row, index)" placeholder="请选择">
              <Option v-for="item in row.glueGoodsNoData" :value="item.goodsNo" :key="item.goodsNo"
                :label="item.goodsNo + (item.brand ? '+' + item.brand : '') + (item.specification ? '+' + item.specification : '') + (item.kweight ? '+' + item.kweight : '')">
              </Option>
            </Select>
          </template>

          <template slot-scope="{ row,index }" slot="remainWeight">
            <Input type="number" v-model.trim="row.remainWeight" clearable placeholder="请输入"
              @on-change="changeRow3(row, index)" />
          </template>
          <template slot-scope="{ row,index }" slot="weightLoss">
            <Input type="number" v-model.trim="row.weightLoss" clearable placeholder="请输入"
              @on-change="changeRow3(row, index)" />
          </template>

        </Table>
      </div>

      <div class="borderDiv marginTop10">
        一级半成品
        <Form inline :label-width="90" class="basicForm" ref="proForm">
          <FormItem class="form-item" label="宽度(mm)">
            <Input class="width160" type="number" readonly="readonly" v-model.trim="fhForm.productWidth"
              placeholder="请输入..." />
          </FormItem>
          <FormItem class="form-item" label="长度(m)">
            <Input class="width160" type="number" clearable v-model.trim="fhForm.productLength" placeholder="请输入..." />
          </FormItem>
          <FormItem class="form-item" label="接头数">
            <Input class="width160" type="number" clearable v-model.trim="fhForm.joint" placeholder="请输入..." />
          </FormItem>
          <FormItem class="form-item" label="" :label-width="0" style="width: 200px">
            <Button type="primary" @click="submitBtn" style="width: 70px">保存</Button>
            <Button type="primary" class="marginLeft20" style="text-align: center"
              @click="printFhBtn('1')">打印标签</Button>
          </FormItem>
          <FormItem class="form-item" label="备注">
            <textarea v-model.trim="fhForm.notes" placeholder="请输入一级半成品备注..."></textarea>
          </FormItem>

        </Form>

        <Row class="marginTop10">
          <Table ref="fhRef" class="table" border :data="fhData" :columns="fhColumns" highlight-row stripe>
          </Table>
        </Row>
      </div>

      <Row style="text-align: center;margin-left: 40%;margin-top: 10px">
        <Button type="primary" @click="finishBtn">完成复合</Button>
        <Button @click="reuniteModalFlag = false" class="marginLeft20" style="width: 70px">取消</Button>
        <Button type="primary" @click="revokeBtn">撤销</Button>
      </Row>
    </Modal>


    <Modal title="一级半成品分割" v-model="cutModalFlag" width="880" footer-hide>
      分割要求
      <Form inline :label-width="120" class="basicForm" ref="proForm">
        <FormItem class="form-item width400" label="产品名称">
          <span>{{ fgOriGoods.productName }}</span>
        </FormItem>
        <FormItem class="form-item width400" label="分割数量">
          <span>{{ fgOriGoods.pbNum }}</span>
        </FormItem>
        <FormItem class="form-item width400" label="已分割长度(m)">
          <span>{{ fgOriGoods.completeLength }}</span>
        </FormItem>
        <FormItem class="form-item width450" label="分割尺寸">
          <span>{{ fgOriGoods.pbWidth }}</span>
        </FormItem>
        <FormItem style="margin-left: 50px;" class="form-item width400" label="已分割数量">
          <span>{{ fgOriGoods.completeNum }}</span>
        </FormItem>
        <FormItem class="form-item" label="备注" style="margin-left: 10px">
          <span>{{ fgOriGoods.customerRemark }}</span>
        </FormItem>
        <!--        <FormItem class="form-item" label="" >-->
        <!--          <Button type="primary"   @click="printFhBtn('2')">同步订单长度</Button>-->
        <!--        </FormItem>-->
      </Form>
      <divider></divider>
      <Button type="primary" @click="addProductBtn">产品添加</Button>
      <Button type="primary" @click="saveFgRow" style="margin-left:10px">保存</Button>

      <Row class="marginTop20">
        <Table class="table" show-summary :summary-method="handleSummary3" border :data="cutData" :columns="cutColumns"
          highlight-row stripe>
          <template slot-scope="{ row,index }" slot="remainLength">
            <Input type="number" v-model.trim="row.remainLength" placeholder="请输入" @on-blur="saveFgLength(row)" />
          </template>
          <template slot-scope="{ row,index }" slot="useLength">
            <Input type="number" v-model.trim="row.useLength" placeholder="请输入" ref="useLength"
              @on-blur="saveFgUseLength(row)" />
          </template>
          <template slot-scope="{ row,index }" slot="joint">
            <Input type="number" v-model.trim="row.joint" placeholder="请输入" @on-blur="saveFgUseLength(row)" />
          </template>
        </Table>
      </Row>
      <Row class="marginTop10" style="margin-top: 20px;margin-bottom: 20px;">
        <h4 style="display:inline-block">已分割完成：</h4>
        <Button type="primary" style="margin-top: -5px" @click="printFhBtn('2')">贴标</Button>
        <!--  <Button type="primary" style="margin-top: -5px;margin-left: 5px;" @click="printFhBtn('2')">打印标签</Button> -->
        <Table ref="fgRef" class="table" border :data="fgTagData" :columns="fgTagColumns" highlight-row stripe>
        </Table>
      </Row>
      <div class="borderDiv marginTop10">
        <h3>打包设置（默认分割完成后自动生成对应的打包记录，可以重新打包）</h3>
        <Form inline :label-width="90" class="basicForm" ref="packForm">
          <FormItem class="form-item" label="" :label-width="0" style="width: 100%;">
            <Select v-model="packForm.orderNo" placeholder="请选择需要打包的客户"
              style="margin-left: 10px;margin-top: -5px;width: 400px;" @on-change="changeFgPackCustomer()">
              <Option v-if="item.unit == '卷'" v-for="item in partNoDetail.partList" :value="item.orderNo"
                :key="item.orderNo">
                {{ item.companyName }}({{ item.productSize }} 共需 {{ item.orderCount }}卷)
              </Option>
            </Select>
            <Button type="primary" @click="savePack" style="width: 100px;">保存打包</Button>
            <Button type="primary" @click="batchPrint" style="width: 100px">打印标签</Button>
          </FormItem>
        </Form>

        <Row>
          <Table ref="fgpackRef" class="table" border :data="packData" :columns="packColumns" highlight-row stripe>
          </Table>
        </Row>
      </div>
      <Row style="text-align: center;margin-left: 40%;margin-top: 10px">
        <Button type="primary" @click="beforeFinisCut">完成分割</Button>
        <Button @click="cutModalFlag = false" class="marginLeft20" style="width: 70px">取消</Button>
        <Button type="primary" @click="revokeBtn">撤销</Button>
      </Row>

    </Modal>

    <Modal title="选择一级半成品" v-model="proSelectModals" width="600" footer-hide>
      <Form inline :label-width="80" class="basicForm" ref="proForm">

        <FormItem class="form-item" label="编码">
          <Input class="width160" type="text" v-model.trim="proSelectForm.encode" placeholder="请输入..." />
        </FormItem>
        <FormItem class="form-item" label="最小宽度">
          <Input class="width160" type="text" readonly v-model.trim="proSelectForm.width" readonly="readonly" />
        </FormItem>
        <FormItem class="form-item" label="最大宽度">
          <Input class="width160" type="text" readonly v-model.trim="proSelectForm.maxWidth" placeholder="请输入..." />
        </FormItem>
        <FormItem class="form-item" label="类型">
          <Select v-model="proSelectForm.type" transfer clearable class="width160">
            <Option value="">全部</Option>
            <Option value="1">一级半成品</Option>
            <Option value="2">二级半成品</Option>
          </Select>
        </FormItem>
        <FormItem class="form-item">
          <Button type="primary" @click="findStoreGoodsList">搜索</Button>
        </FormItem>
      </Form>
      <Row class="marginTop20">
        <Table :height="600" class="table" ref="proSelectTab" border :data="proSelectData" :columns="proSelectColumns"
          highlight-row stripe>
        </Table>
      </Row>
      <Row style="text-align: center;margin-left: 40%;margin-top: 10px">
        <Button type="primary" @click="sureProBtn">确定</Button>
        <Button @click="proSelectModals = false" class="marginLeft20" style="width: 70px">取消</Button>
      </Row>

    </Modal>

    <Modal title="成品裁切" v-model="sliceModalFlag" width="900" footer-hide>

      <h3 style="display:inline-block">二级半成品：</h3>
      <Button type="primary" style=" margin-top: 10px;" @click="addProductBtnTwo">产品添加</Button>
      <Tag>需要走损耗的二级半成品，修改剩余长度，然后删除即可</Tag>
      <Row class="marginTop20">
        <Table class="table" show-summary :summary-method="handleSummary" border :data="sliceData"
          :columns="sliceColumns" highlight-row stripe>
          <template slot-scope="{ row,index }" slot="remainLength">
            <Input type="number" v-model.trim="row.remainLength" clearable placeholder="请输入"
              @on-blur="saveLength(row)" />
          </template>
        </Table>
      </Row>
      <!-- 產品添加 -->
      <Modal title="选择二级半成品" v-model="proSelectModal" width="600" footer-hide>
        <Form inline :label-width="80" class="basicForm" ref="proForm">
          <FormItem class="form-item" label="编码">
            <Input class="width160" type="text" v-model.trim="proSelectForm.encode" placeholder="请输入..." />
          </FormItem>
          <FormItem class="form-item" label="最小宽度">
            <Input class="width160" type="text" v-model.trim="proSelectForm.width" />
          </FormItem>
          <FormItem class="form-item" label="最大宽度">
            <Input class="width160" type="text" v-model.trim="proSelectForm.maxWidth" placeholder="请输入..." />
          </FormItem>
          <FormItem class="form-item" label="类型">
            <Select v-model="proSelectForm.type" transfer clearable class="width160">
              <Option value="1">一级半成品</Option>
              <Option value="2">二级半成品</Option>
            </Select>
          </FormItem>
          <FormItem class="form-item">
            <Button type="primary" @click="findStoreCqGoodsList">搜索</Button>
          </FormItem>

        </Form>
        <Row class="marginTop20">
          <Table :height="600" class="table" ref="proSelectTabTwo" border :data="proSelectDataTwo"
            :columns="proSelectColumn" highlight-row stripe>

          </Table>
        </Row>
        <Row style="text-align: center;margin-left: 40%;margin-top: 10px">
          <Button type="primary" @click="sureProBtnTwo">确定</Button>
          <Button @click="proSelectModal = false" class="marginLeft20" style="width: 70px">取消</Button>

        </Row>

      </Modal>
      <h3 style="margin-top:10px">订单规格</h3>
      <Form inline :label-width="110" class="basicForm" ref="proForm">
        <FormItem class="form-item" label="宽度(mm)">
          <Input class="width160" type="text" readonly v-model.trim="partNoDetail.productWidth" placeholder="请输入..." />
        </FormItem>
        <FormItem class="form-item" label="长度(mm)">
          <Input class="width160" type="number" readonly v-model.trim="partNoDetail.productLength"
            placeholder="请输入..." />
        </FormItem>
        <FormItem class="form-item" :label="`裁切数量(` + partNoDetail.unit + `)`" style="margin-left: 10px">
          <Input class="width160" type="number" readonly v-model.trim="partNoDetail.count" placeholder="请输入..." />
        </FormItem>
        <FormItem class="form-item" label="备注" prop="joint">
          <Input class="width160" type="text" readonly v-model.trim="partNoDetail.customerRemark" />
        </FormItem>
      </Form>

      <div class="borderDiv ">
        <span style="font-size: 16px;color:#515A6E;font-weight: bold">生产规格</span>
        <Button type="primary" size="small" style="float: right;margin-top: -5px" @click="printFhBtn('3')">打印标签</Button>
        <Button type="primary" size="small" style="float: right;margin-top: -5px;margin-right: 10px"
          @click="saveSliceBtn">保存</Button>
        <Form inline :label-width="110" class="basicForm" ref="produceForm">
          <FormItem class="form-item" label="半成品">
            <Select v-model="proId" class="width160" placeholder="请选择" @on-change="selectSlicePro">
              <Option v-for="item in sliceData" :value="item.id" :key="item.id" :label="item.goodsNo"></Option>
            </Select>
          </FormItem>
          <FormItem class="form-item" label="宽度(mm)" prop="productWidth">
            <Input class="width160" type="number" readonly v-model.trim="produceForm.productWidth" placeholder="自动带出" />
          </FormItem>
          <FormItem class="form-item" label="长度(m)" prop="productLength">
            <Input class="width160" type="number" readonly v-model.trim="produceForm.productLength"
              placeholder="自动带出" />
          </FormItem>
          <FormItem class="form-item" label="实际裁切数量" prop="num">
            <Input class="width160" type="number" v-model.trim="produceForm.num" placeholder="请输入..." />
          </FormItem>
          <FormItem class="form-item" label="接头数(个)" prop="totalJoint">
            <Input class="width160" type="number" readonly v-model.trim="produceForm.totalJoint" placeholder="自动带出" />
          </FormItem>
          <FormItem class="form-item" label="抽取接头" prop="joint">
            <Input class="width160" type="number" clearable v-model.trim="produceForm.joint" placeholder="请输入..." />
          </FormItem>
          <FormItem class="form-item" label="总完成数量">
            <Input class="width160" @on-blur="calExpectNum" type="number" clearable v-model.trim="produceForm.sum"
              placeholder="请输入..." />
          </FormItem>
        </Form>
        <Row>
          <Table ref="cqRef" class="table" border :data="produceData" show-summary :summary-method="handleSummaryCq"
            :columns="produceColumns" highlight-row stripe @on-selection-change="selectionCQToPackAge">
            <!--        <template slot-scope="{ row,index }" slot="num">
            <Input type="number" v-model.trim="row.num" placeholder="请输入" ref="num" @on-change="changeCqPackageCount"  />
          </template> -->
          </Table>
        </Row>
      </div>


      <div class="borderDiv marginTop10">
        <h3>打包设置</h3>
        <Form inline :label-width="90" class="basicForm" ref="packForm">
          <FormItem class="form-item" label="每包数量">
            <Input class="width160" type="number" clearable v-model.trim="packForm.perNum" placeholder="请输入..." />
          </FormItem>
          <FormItem class="form-item" label="总数">
            <Input class="width160" readonly="readonly" disabled type="number" clearable v-model.trim="packForm.count"
              placeholder="请选择需要打包的产品" />
          </FormItem>
          <FormItem class="form-item" label="" :label-width="0" style="width: 230px">
            <Button type="primary" @click="savePack" style="width: 100px">保存打包</Button>
            <Button type="primary" @click="batchPrint" style="width: 100px">打印标签</Button>
          </FormItem>
        </Form>

        <Row>
          <Table ref="cqpackRef" class="table" border :data="packData" :columns="packColumns" highlight-row stripe>
          </Table>
        </Row>
      </div>

      <Row style="text-align: center;margin-left: 40%;margin-top: 10px">
        <Button type="primary" @click="finishSliceBtn">完成裁切</Button>
        <Button @click="sliceModalFlag = false" class="marginLeft20" style="width: 70px">取消</Button>
        <Button type="primary" @click="revokeBtn">撤销</Button>
      </Row>
    </Modal>


    <Modal title="打包" v-model="packModalFlag" width="1000" footer-hide>
     
        <Row>
          <Form inline :label-width="90" class="basicForm" ref="packForm">
           
            <FormItem class="form-item" label="类型">
                  <Select v-model="searchFormPackAgess.level" transfer clearable class="width160">
                    <Option value="2">二级</Option>
                    <Option value="3">成品</Option>
                  </Select>
                </FormItem>
            <FormItem>
              <Button type="primary" @click="getGoodsListFun">查询</Button>
            </FormItem>
          </Form>
        </Row>
        <Row class="marginTop10">
          <Table ref="DdbPackRefss" @on-selection-change="selectTab" class="table" border :data="packageAddGoodsData" :columns="packageAddGoodsColumns"
            highlight-row stripe>
          </Table>
          
          <Page :current="pageNumPackAgesss" :page-size="pageSizePackAgesss" :total="totalPackAgesss" @on-change="handleChangePagePackAgesss"
                  @on-page-size-change="handlePageSizeChangePackAgesss" show-total show-sizer
                  style="margin-top:10px;text-align: center;" />
                  <div style="display: flex;flex-direction: row;align-items: center;margin-top: 10px;" v-if="packAgeObj.unit == '张'">
                      <div style="margin-left: 35px;">共：{{ sumNumber }} 张</div>
                      <div style="display: flex;flex-direction: row;align-items: center;margin-left: 35px;">
                        <div>每包张数：</div>
                        <Input class="width90"  @on-change="getVal"  type="number" clearable v-model.trim="paperNumber"
                          placeholder="请输入" />
                      </div>
                      <div style="margin-left: 35px;">共：{{ ballNumber }} 包</div>
                      
                    </div>
                 
        </Row>
      <Row style="text-align: center;margin-left: 40%;margin-top: 20px">
        <Button type="primary" @click="finishPackBtn">打包</Button>
        <Button @click="packModalFlag = false" class="marginLeft20" style="width: 70px">取消</Button>
      </Row>

    </Modal>
    <!-- 查询打包可用的半成品信息 -->
    <Modal title="选择打包产品" v-model="proPackageSelectModal" width="600" footer-hide>
      <Form inline :label-width="100" class="basicForm" ref="proForm">

        <FormItem class="form-item" label="类型">
          <Select v-model="proSelectForm.goodsType" transfer clearable class="width160">
            <Option v-if="proSelectForm.unit == '卷'" value="2">二级半成品</Option>
            <Option v-if="proSelectForm.unit == '卷'" value="1">一级半成品</Option>
            <Option v-if="proSelectForm.unit == '张'" value="3">成品</Option>
          </Select>
        </FormItem>
        <FormItem class="form-item" label="编码">
          <Input class="width160" type="text" v-model.trim="proSelectForm.encode" placeholder="请输入..." />
        </FormItem>
        <FormItem class="form-item" label="宽度(mm)">
          <Input class="width160" type="text" v-model.trim="proSelectForm.width" placeholder="请输入..." />
        </FormItem>
        <FormItem class="form-item" label="长度(mm)">
          <Input class="width160" type="text" v-model.trim="proSelectForm.length" placeholder="请输入..." />
        </FormItem>
        <Button type="primary" @click="getPackageProductList">搜索</Button>
      </Form>
      <Row class="marginTop20">
        <Table :height="600" class="table" ref="proPackageSelectTab" border :data="packageSelectGoodsData"
          :columns="packageSelectGoodsColumns" highlight-row stripe>
        </Table>
      </Row>
      <Row style="text-align: center;margin-left: 40%;margin-top: 20px">
        <Button type="primary" @click="surePackageProBtn">确定</Button>
        <Button @click="proSelectModals = false" class="marginLeft20" style="width: 70px">取消</Button>

      </Row>

    </Modal>
    <!--修改状态-->
    <!-- modelTitle -->
    <Modal title="修改" v-model="updateModalFlagOne" footer-hide>
      <Form ref='searchForm' :label-width="90" inline>
        <FormItem label="级别">
          <Select v-model="selectedRow.level" class="width360">
            <Option value="1">正常</Option>
            <Option value="2">紧急</Option>
          </Select>
          
        </FormItem>
        <FormItem label="机器">
          <Select v-model="selectedRow.machineName"  clearable class="width360" placeholder="请选择">
                    <Option v-for="item in processData" :value="item.name" :key="item.name" :label="item.name"></Option>
                  </Select>
        </FormItem>
        
      </Form>
      <Row style="text-align: center;margin-left: 35%">
        <Button type="primary" @click="submitUpdate" style="width: 70px">确定</Button>
        <Button @click="updateModalFlagOne = false" class="marginLeft20" style="width: 70px">取消</Button>
      </Row>
    </Modal>
    <!--切换设备-->
    <Modal title="切换设备" v-model="changeEquipFlag" footer-hide>
      <Form :label-width="150" inline>
        <FormItem label="设备" width="150">
          <Select width="150" v-model="equipForm.equipId" transfer placeholder="请选择">
            <Option v-for="item in equipData" :value="item.equipId" :key="item.equipId" :label="item.equipName">
            </Option>
          </Select>
        </FormItem>
      </Form>
      <Row style="text-align: center;margin-left: 35%">
        <Button type="primary" @click="submitChangeEquip" style="width: 70px">确定</Button>
        <Button @click="changeEquipFlag = false" class="marginLeft20" style="width: 70px">取消</Button>
      </Row>
    </Modal>


  </div>

</template>

<script>
import {
  printNewFhPaper,
  cancleFgGoods,
  cancleDbGoods,
  addPackage,
  addPack,
  cancleCqGoods,
  saveUseFgGoods,
  modyFgOriGoodsLength,
  chooseFgGoods,
  findGoodsList,
  getGoodsList,
  findListByProductId,
  chooseCqGoods,
  updatePartType,
  getChildPackageList,
  printCutPDF,
  printCqPapers,
  cutPaperSlicePDF,
  printFgPapers,
  printPackPDF,
  cutPaperPDF,
  saveCut,
  printFhPaper,
  partingPDF,
  complexPDF,
  printPdf,
  finishPackage,
  savePackage,
  packageDecals,
  getPackageList,
  queryPackageListByBatch,
  modyRemainCqLength,
  findProductTreeList,
  getFhGoods,
  getPbList,
  completeCqGoods,
  addCqGoods,
  completeFgGoods,
  getProcessList,
  getPage,
  getEquipList,
  getCustomerListSlice,
  getCutPaperPasteList,
  getPartNoDetail,
  getPartNoDetailTwo,
  getGoodsNoList,
  savePartGoodSource,
  getPrintSource, //打印标签
  addFhGoods,
  completeFhGoods,
  // findPackageProductList,
  addPackageGoods,
  savePackageGoods,
  changeEquip, //切换设备
  completeTip, //完成工序二次提醒
  deleteGoodsSource, //删除不需要复合的产品
  deleteFgGoods, //删除不需要的尾料
  revokeOrder, //撤销操作
  saveProductPackage, //裁切后打包
  revokePack, //撤回打包
  getOptNo,
  getCustomerList,
  getSplitsPage,
  getSlicePage,
  cutCommonUpdate,
  getPackageLists,
  cutCommonDelete,
  cutCommonFulfill,
  getNoPasteProNameList,
  getNoSliceProNameList,
  getNoMakeupProNameList,
  getNoSplitsProNameList,
  getNoPackageProNameList,
} from "@/api/index"
import pbPart from './pbPart'
import  bigBoardExpandRow  from './bigBoardExpandRowNew.vue';
import processProgress from './processProgress'
import {
  formatDate
} from "@/api/util";
export default {
  name: "index",
  components: {
    pbPart,
    processProgress
  },
  data() {
    return {
      sumNumber:0,
      ballNumber:0,
      paperNumber:0,
      saveAllFgRowList: [],
      proSelectForm: {},
      searchFormSlice:{
        status:'0',
      },
      modelTitle:'',
      customerList:[],
      updateModalFlagOne:false,
      equipForm: {},
      equipId: 0, //设备id
      selectPackOrder: { //分割打包保存需要的参数
        orderNo: "",
        list: []
      }, //选择打包的产品
      proSelectColumns: [
        {
          type: 'selection',
          align: 'center',
          width: 60
        },
        {
          title: "序号",
          type: "index",
          width: 70,
          align: "center"
        },
        {
          key: "goodsNo",
          title: "物品编号",
          align: "center",
        },
        {
          key: "productWidth",
          title: "宽度",
          align: "center",
        },
        {
          key: "productLength",
          title: "长度(m)",
          align: "center",
          render: (h, params) => {
            let data = "";
            if (params.row.productLength) {
              data = params.row.productLength / 1000;
            }

            return h("span", data);
          }
        },
      ],
      proSelectColumn: [{
        type: 'selection',
        align: 'center',
        width: 60
      },
      {
        title: "序号",
        type: "index",
        width: 70,
        align: "center"
      },
      {
        key: "goodsNo",
        title: "物品编号",
        align: "center",
      },
      {
        key: "productWidth",
        title: "宽度",
        align: "center",
      },
      {
        key: "productLength",
        title: "长度(m)",
        align: "center",
        render: (h, params) => {
          let data = "";
          if (params.row.productLength) {
            data = params.row.productLength / 1000;
          }

          return h("span", data);
        }
      }
      ],
      proSelectData: [],
      productList:[],
      proSelectDataTwo: [],
      newStatus: "",
      updateModalFlag: false,
      printLoading: false,
      changeEquipFlag: false,
      changeEquipList: [],
      packData: [],
      packColumns: [{
        type: 'selection',
        align: 'center',
        width: 50
      },
      {
        title: "序号",
        type: "index",
        width: 70,
        align: "center"
      },
      // {
      //   key: "batch",
      //   title: "批次",
      //   width: 70,
      //   align: "center",
      // },
      {
        key: "num",
        title: "每包数",
        width: 80,
        align: "center",
      },
      {
        key: "batchNum",
        title: "总数",
        align: "center",
        width: 150,
        render: (h, params) => {
          var num = params.row.batchNum;
          if (params.row.unit == '卷') {
            var size = params.row.productSize;
            num = size + "*" + num;
          }
          return h("span", num);
        }
      },
      {
        key: "count",
        title: "总包数",
        align: "center",
        width: 80,
      },
      {
        key: "goodsNo",
        title: "产品编号",
        align: "center",
        width: 100,
      },
      {
        key: "companyName",
        title: "客户名称",
        align: "center",
        width: 110,
      },
      {
        key: "createTime",
        title: "打包时间",
        align: "center",
        width: 100,
      },
      {
        title: "操作",
        key: "action",
        width: 120,
        align: "center",
        render: (h, params) => {
          return h("div", [
            h(
              "div", {
              class: {
                'iconfont table-print table-button-div color-blue': true
              },
              domProps: {
                title: '打印标签'
              },
              on: {
                click: () => { //编辑
                  this.printPackBtn(params.row.orderNo, params.row.batch);
                }
              }
            },
              ""
            ),
            h(
              "div", {
              class: {
                'iconfont table-delete table-button-div color-light-red': true
              },
              domProps: {
                title: '删除'
              },
              on: {
                click: () => { //撤回打包 revokePack
                  //撤回 revokePack
                  this.$Modal.confirm({
                    title: "撤销打包",
                    content: "是否撤销当前批次打包（撤回后会将原本打包的数据还原到仓库里）?",
                    onOk: () => {

                      revokePack({
                        orderNo: params.row.orderNo,
                        batch: params.row.batch,
                        json: params.row.goodsJson,
                      })
                        .then(res => {
                          if (res.code == 200) {
                            this.$Message.success('撤回打包成功！');
                            this.getOneDetail()
                          }
                        })

                    }
                  });


                }
              }
            },
              ""
            ),
          ]);

        }
      }
      ],
      packForm: {},
      packModalFlag: false,
      timeNum: 300,
      refreshWay: 1,
      productList: [],
      produceData: [],
      produceColumns: [{
        type: 'selection',
        align: 'center',
        width: 60
      }, {
        title: "序号",
        type: "index",
        width: 70,
        align: "center"
      },
      {
        key: "goodsNo",
        title: "物品编号",
        align: "center",
      },
      {
        key: "productWidth",
        title: "宽度(mm)",
        align: "center",

      },
      {
        key: "productLength",
        title: "长度(mm)",
        align: "center",
      },
      {
        key: "num",
        title: "数量",
        align: "center",
        slot: 'num',
        render: (h, params) => {
          return h('Input', {
            props: {
              value: this.produceData[params.index].num
            },
            on: {
              'input': (val) => {
                //console.log(val)
                this.produceData[params.index].num = val;
                this.packForm.count = 0;
              }
            }
          })
        }
      },

      ],

      packageSelectGoodsData: [],
      packageSelectGoodsColumns: [{
        type: 'selection',
        align: 'center',
        width: 60
      },
      {
        title: "序号",
        type: "index",
        width: 70,
        align: "center"
      },
      {
        key: "productName",
        title: "产品名称",
        align: "center",
      },
      {
        key: "goodsNo",
        title: "物品编号",
        align: "center",
      },
      {
        key: "productWidth",
        title: "宽度(mm)",
        align: "center",
      },
      {
        key: "length",
        title: "长度(m)",
        align: "center",
        render: (h, params) => {
          return h("span", params.row.productLength / 1000);
        }
      },
      {
        key: "num",
        title: "数量",
        align: "center"
      }

      ],
      proPackageSelectModal: false,
      packageAddGoodsData: [],
      packageAddGoodsColumns: [{
        type: 'selection',
        align: 'center',
        width: 60
      },
      // {
      //   title: "序号",
      //   type: "index",
      //   width: 70,
      //   align: "center"
      // },
      {
          title: "类型",
          key: "level",
          align: "center",
          width: 100,
          render: (h, params) => {
            let data = "";
            let className = '';
            switch (Number(params.row.level)) {
              case 2:
                data = "二级";
                className = 'table-status  border-color-blue';
                break;
              case 3:
                data = "成品";
                className = 'table-status border-color-orange';
                break;
            }

            return h(
              "button", {
                attrs: {
                  class: className
                }
              },
              data
            )
          }
        },
      {
        key: "code",
        title: "物料编号",
        align: "center",
      },
      {
        key: "wide",
        title: "宽度(mm)",
        align: "center",
      },
      {
        key: "remLen",
        title: "长度(m)",
        align: "center"
      },
      {
        key: "num",
        title: "数量",
        align: "center",
      },
      {
        key: "unit",
        title: "单位",
        align: "center",
      },
      {
          title: '使用数量(长度)',
          key: 'useNo',
          align: 'center',
          // width: 250,
          render: (h, params) => {
            let _this = this;
            return h('Input', {
              style: {
                width: '100%',
                textAlign: 'center'
              },
              props: {
                value: params.row.useNo||'',
                type: 'number'
              },
              on: {
                'on-change': e => {
                  if (e.target.value !== '' && e.target.value !== null && e.target.value !== undefined) {
                    params.row.useNo = Number(e.target.value);
                  } else {
                    params.row.useNo = e.target.value;
                  }
                  this.$set(_this.packageAddGoodsData, params.index, params.row);

                }
              }
            });

          }
        },
      // {
      //   title: "操作",
      //   key: "action",
      //   align: "center",
      //   render: (h, params) => {
      //     return h("div", [
      //       h(
      //         "div", {
      //         class: {
      //           'iconfont table-delete table-button-div color-light-red': true
      //         },
      //         domProps: {
      //           title: '删除'
      //         },
      //         on: {
      //           click: () => { //编辑

      //             cancleDbGoods({
      //               id: params.row.id
      //             })
      //               .then(res => {
      //                 if (res.code == 200) {
      //                   this.$Message.success('删除成功！');
      //                   this.getOneDetail()
      //                 }
      //               })
      //           }
      //         }
      //       },
      //         ""
      //       ),
      //     ]);
      //   }
      // }

      ],
      produceForm: {},
      sliceData: [],
      sliceColumns: [{
        title: "序号",
        type: "index",
        width: 50,
        align: "center"
      },
      {
        key: "productName",
        title: "产品名称",
        align: "center",
      },
      {
        key: "goodsNo",
        title: "产品编号",
        align: "center",
      },
      {
        key: "productWidth",
        title: "宽度(mm)",
        align: "center",
      },
      {
        // key: "pbLength",
        key: "productLength",
        title: "长度(m)",
        align: "center",
      },
      {
        key: "pbLength",
        /*key: "productLength",*/
        title: "裁切长度(mm)",
        align: "center",
        render: (h, params) => {
          return h("span", params.row.productLength*1000);
        },
      },
      {
        key: "num",
        title: "预期数量",
        align: "center",
      },
      {
        key: 'remainLength',
        title: "剩余长度(m)",
        align: "center",
        width: 100,
        slot: 'remainLength'
      },
      {
        title: "操作",
        key: "action",
        align: "center",
        width: 130,
        render: (h, params) => {
          return h("div", [
            h(
              "div", {
              class: {
                'iconfont table-delete table-button-div color-light-red': true
              },
              domProps: {
                title: '删除'
              },
              on: {
                click: () => { //编辑

                  this.$Modal.confirm({
                    title: "删除半成品",
                    content: "是否确认删除当前半成品?",
                    onOk: () => {
                      cancleCqGoods({
                        id: params.row.id
                      })
                        .then(res => {
                          if (res.code == 200) {
                            this.$Message.success('删除成功！');
                            this.getOneDetail()
                          }
                        })
                    }
                  });

                }
              }
            },
              ""
            ),
            h(
              "div", {
              class: {
                'iconfont table-print table-button-div color-orange': true
              },
              domProps: {
                title: '打印'
              },
              on: {
                click: () => { //编辑
                  this.printOnePdf(params.row);
                }
              }
            },
              ""
            ),
          ]);
        }
      }

      ],
      sliceModalFlag: false,
      fgOriGoods: {},
      cutData: [],
      cutColumns: [{
        title: "序号",
        type: "index",
        width: 70,
        align: "center"
      },
      {
        key: "goodsNo",
        title: "物品编号",
        align: "center",
      },
      {
        key: "productLength",
        title: "长度(m)",
        align: "center",
        render: (h, params) => {
          let data = "";
          if (params.row.productLength) {
            data = params.row.productLength / 1000;
          }

          return h("span", data);
        }
      },
      {
        key: "productWidth",
        title: "宽度(mm)",
        align: "center",
      },
      {
        key: "remainLength",
        title: "实际长度(m)",
        align: "center",
        slot: 'remainLength'
      },
      {
        key: "useLength",
        title: "使用长度(m)",
        align: "center",
        slot: 'useLength'
      },
      {
        key: "joint",
        title: "接头数",
        align: "center",
        slot: 'joint'
      },
      {
        title: "操作",
        key: "action",
        align: "center",

        render: (h, params) => {
          return h("div", [
            // h(
            //   "div", {
            //     class: {
            //       'iconfont table-agree table-button-div color-blue': true
            //     },
            //     domProps: {
            //       title: '保存'
            //     },
            //     on: {
            //       click: () => { //编辑
            //         this.saveFgRow(params.row);
            //       }
            //     }
            //   },
            //   ""
            // ),
            h(
              "div", {
              class: {
                'iconfont table-delete table-button-div color-light-red': true
              },
              domProps: {
                title: '删除'
              },
              on: {
                click: () => { //编辑
                  cancleFgGoods({
                    id: params.row.id
                  })
                    .then(res => {
                      if (res.code == 200) {
                        this.$Message.success('删除成功！');
                        this.getOneDetail()
                      }
                    })
                }
              }
            },
              ""
            ),
          ]);
        }
      }


      ],
      cutModalFlag: false,
      fhColumns: [{
        type: 'selection',
        align: 'center',
        width: 60
      },
      {
        title: "序号",
        type: "index",
        width: 70,
        align: "center"
      },
      {
        key: "goodsNo",
        title: "一级半成品编号",
        align: "center",

      },

      {
        key: "productWidth",
        title: "宽度(mm)",
        align: "center",

      },
      {
        key: "productLength",
        title: "长度(m)",
        align: "center",
        render: (h, params) => {
          let data = "";
          if (params.row.productLength) {
            data = params.row.productLength / 1000;
          }

          return h("span", data);
        }

      },
      {
        key: "joint",
        title: "接头数",
        align: "center",
      },
      {
        key: "notes",
        title: "备注",
        align: "center",
      },
      ],
      fhData: [],
      fhForm: {},
      fgTagColumns: [{ //分割打印标签
        type: 'selection',
        align: 'center',
        width: 60
      },
      {
        title: "序号",
        type: "index",
        width: 70,
        align: "center"
      },
      {
        key: "goodsNo",
        title: "半成品编号",
        align: "center",
        width: 100,
        render: (h, params) => {
          let data = params.row.isComplete;
          let bgColor = "";
          if (data == 1) {
            bgColor = "yellow";
          }
          return h("div", [
            h(
              "span", {
              style: {
                background: bgColor,
              },
            },
              params.row.goodsNo
            ),
          ]);
        },
      },
      {
        key: "companyName",
        title: "客户名称",
        align: "center",
        width: 100
      },
      {
        key: "productWidth",
        title: "宽度(mm)",
        align: "center",
      },
      {
        key: "productLength",
        title: "长度(m)",
        align: "center",
        render: (h, params) => {
          let data = "";
          if (params.row.productLength) {
            data = params.row.productLength / 1000;
          }
          return h("span", data);
        }
      },
      {
        key: "createTime",
        title: "时间",
        align: "center",
        width: 180,
      },
      {
        title: "操作",
        key: "action",
        align: "center",
        render: (h, params) => {
          return h("div", [
            h(
              "div", {
              class: {
                'iconfont table-delete table-button-div color-light-red': true
              },
              domProps: {
                title: '删除'
              },
              on: {
                click: () => { //
                  //如果已经被打包了，不可以删除
                  // if (params.row.isComplete == 1) {
                  //   this.$Message.warning('该半成品已被打包，不可以删除，如需要删除请撤回下方打包后在仓库中删除！');
                  //   return;
                  // }
                  this.$Modal.confirm({
                    title: "删除半成品",
                    content: "是否确认删除当前半成品（确认后会同步删除仓库该半成品信息）?",
                    onOk: () => {
                      deleteFgGoods({
                        id: params.row.id
                      })
                        .then(res => {
                          if (res.code == 200) {
                            this.$Message.success('删除成功！');
                            this.getOneDetail()
                          }
                        })

                    }
                  });



                }
              }
            },
              ""
            ),
          ]);
        }
      }

      ],
      fgTagData: [],
      glueGoodsNoData: [],
      facialGoodsNoData: [],
      backPaperGoodsNoData: [],
      glueGoodsNameData: [],
      facialGoodsNameData: [],
      backPaperGoodsNameData: [],
      glueGoodsNameList: [],
      facialGoodsNameList: [],
      backPaperGoodsNameList: [],
      searchFormPackAgess:{},
      userName: '',
      reuniteModalFlag: false,
      proForm: {},
      activeEquip: '',
      activeTab: 0,
      searchForm: {
        status:'0',
      },
      searchFormSplit: {
        status:'0',
      },
      tableData: [],
      tableDataSplit: [],
      tableFhColumns: [
        // {
        //   type: 'selection',
        //   align: 'center',
        //   width: 60
        // },
        {
          title: "序号",
          type: "index",
          width: 70,
          align: "center"
        },
        // {
        //   title: "类型",
        //   key: "type",
        //   align: "center",
        //   width: 100,
        //   render: (h, params) => {
        //     let data = "";
        //     let className = '';
        //     switch (Number(params.row.type)) {
        //       case 0:
        //         data = "复合";
        //         className = 'table-status  border-color-blue';
        //         break;
        //       case 1:
        //         data = "拼版";
        //         className = 'table-status border-light-green';
        //         break;
        //       case 2:
        //         data = "分割";
        //         className = 'table-status border-color-orang';
        //         break;
        //       case 3:
        //         data = "裁切";
        //         className = 'table-status border-color-purple';
        //         break;
        //     }

        //     return h(
        //       "button", {
        //         attrs: {
        //           class: className
        //         }
        //       },
        //       data
        //     )
        //   }
        // },
        {
          key: "code",
          title: "订/工单编号",
          align: "center",
          width: 180,
        },
        {
          key: "name",
          title: "产品名称",
          width: 220,
          align: "center"
        },
        {
          key: "wide",
          title: "宽(mm)",
          align: "center",
          width: 100,
        },
        {
          key: "lengths",
          title: "长(m)",
          align: "center",
          width: 100,
        },

        {
          key: "num",
          title: "数量",
          align: "center",
          width: 100,
        },
        {
          key: "unit",
          title: "单位",
          align: "center",
          width: 100,
        },
        {
          title: "状态",
          key: "status",
          align: "center",
          width: 100,
          render: (h, params) => {
            let data = "";
            let className = '';
            switch (Number(params.row.status)) {
              case 0:
                data = "未生产";
                className = 'table-status border-color-orange';
                break;
              case 1:
                data = "生产中";
                className = 'table-status  border-color-blue';
                break;
              case 2:
                data = "生产完成";
                className = 'table-status border-light-green';
                break;
            }

            return h(
              "div", {
              attrs: {
                class: className
              }
            },
              data
            )
          }
        },
        {
          title: "级别",
          key: "level",
          align: "center",
          width: 100,
          render: (h, params) => {
            let data = "";
            let className = '';
            switch (Number(params.row.level)) {
              case 1:
                data = "正常";
                className = 'table-status border-color-blue';
                break;
              case 2:
                data = "紧急";
                className = 'table-status border-red';
                break;
            }

            return h(
              "div", {
              attrs: {
                class: className
              }
            },
              data
            )
          }
        },
        {
          key: "machineName",
          title: "机器",
          align: "center",
          width: 180,
        },
        {
          key: "remark",
          title: "备注",
          align: "center",
          width: 270,
        },
        {
          key: "operateTime",
          title: "时间",
          align: "center",
          width: 200,
        },
        {
          title: "操作",
          key: "action",
          width: 250,
          align: "center",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              // h(
              //   "div", {
              //     class: {
              //       'iconfont table-shengchan table-button-div color-blue': true
              //     },
              //     domProps: {
              //       title: '操作'
              //     },
              //     on: {
              //       click: () => { //编辑
              //         this.editRow(params.row);
              //       }
              //     }
              //   },
              //   ""
              // ),
              h(
                "button", {
                  style: {
                          marginRight: "10px",
                          display:"inline",
                          cursor: 'pointer',
                          padding:"2px 6px",
                          background:'#326CFB',
                          color:"white",
                          // borderRadio:'5px',
                          border:"none",
                      },
                on: {
                  click: () => { //修改状态
                    this.editStatusOne(params.row);
                  }
                }
              },
                "修改"
              ),
              h(
                "button", {
                  style: {
                          marginRight: "10px",
                          display:"inline",
                          cursor: 'pointer',
                          padding:"2px 6px",
                          background:'#FF9900',
                          color:"white",
                          // borderRadio:'5px',
                          border:"none",
                      },
                on: {
                  click: () => { //修改状态
                    this.$router.push({
                      name: "fuHAdd"
                    });
                    window.sessionStorage.setItem("objFuhe", JSON.stringify(params.row));
                  }
                }
              },
                "复合"
              ),
              h(
                "button", {
                  style: {
                          marginRight: "10px",
                          display:"inline",
                          cursor: 'pointer',
                          padding:"2px 6px",
                          background:'rgb(253, 90, 91)',
                          color:"white",
                          // borderRadio:'5px',
                          border:"none",
                      },
                on: {
                  click: () => { //修改状态
                    this.$Modal.confirm({
                title: "确认",
                content: "是否确认删除?",
                onOk: () => {
                  cutCommonDelete({
                    id:params.row.id,
                    type:0,
                  }).then( res => {
                    if(res.code == 200){
                      this.searchData()
                      this.$Message.success('删除成功！');
                      

                    }
                  })
                }
              });
                  }
                }
              },
                "删除"
              ),
              h(
                "button", {
                  style: {
                          marginRight: "10px",
                          display:"inline",
                          cursor: 'pointer',
                          padding:"2px 6px",
                          background:'rgb(60, 212, 151)',
                          color:"white",
                          // borderRadio:'5px',
                          border:"none",
                      },
                on: {
                  click: () => { //修改状态
                    this.$Modal.confirm({
                title: "确认",
                content: "是否确认完成?",
                onOk: () => {
                  cutCommonFulfill({
                    id:params.row.id,
                    type:0,
                  }).then( res => {
                    if(res.code == 200){
                      this.searchData()
                      this.$Message.success('操作成功！');
                    }
                  })
                }
              });
                  }
                }
              },
                "完成"
              ),
              // h(
              //   "div", {
              //     class: {
              //       'iconfont table-waixie table-button-div color-blue': true
              //     },
              //     domProps: {
              //       title: '切换设备'
              //     },
              //     on: {
              //       click: () => { //修改状态
              //         this.changeEquipFlag = true;
              //         this.equipForm.equipId = this.activeEquip;
              //         this.equipForm.partNo = params.row.partNo;
              //       }
              //     }
              //   },
              //   ""
              // ),
            ]);
            //changeEquip
          }
        }
      ],
      bigBoardData:[],

      tableFhColumnsSplit: [
        {
          title: "序号",
          type: "index",
          width: 70,
          align: "center"
        },
        {
          title: "分割类型",
          key: "type",
          align: "center",
          width: 100,
        },
        {
          key: "code",
          title: "订/工单编号",
          align: "center",
          width: 180,
        },
        {
          key: "name",
          title: "产品名称",
          width: 220,
          align: "center"
        },
        {
          key: "customer",
          title: "客户名称",
          width: 180,
          align: "center"
        },
        {
          key: "wide",
          title: "物料幅宽(mm)",
          align: "center",
          width: 100,
        },
        {
          key: "splitsWideStr",
          title: "分割宽度(mm)",
          align: "center",
          width: 100,
        },
        {
          key: "splitsOneLength",
          title: "分割长度(m)",
          align: "center",
          width: 100,
        },
        {
          key: "splitsTotalLength",
          title: "分割总长度(m)",
          align: "center",
          width: 100,
        },
        {
          key: "spliteNo",
          title: "分割数",
          align: "center",
          width: 100,
        },
        {
          key: "unit",
          title: "单位",
          align: "center",
          width: 100,
        },
        {
            title: "状态",
            key: "status",
            align: "center",
            width: 100,
            render: (h, params) => {
              let data = "";
              let className = '';
              switch (Number(params.row.status)) {
                case 0:
                  data = "未分割";
                  className = 'table-status border-color-orange';
                  break;
                  case 1:
                  data = "分割中";
                  className = 'table-status border-color-blue';
                  break;
                case 2:
                  data = "分割完成";
                  className = 'table-status border-light-green';
                  break;
              }

              return h(
                "button", {
                  attrs: {
                    class: className
                  }
                },
                data
              )
            }
          },
        {
          title: "级别",
          key: "level",
          align: "center",
          width: 100,
          render: (h, params) => {
            let data = "";
            let className = '';
            switch (Number(params.row.level)) {
              case 1:
                data = "正常";
                className = 'table-status  border-color-blue';
                break;
              case 2:
                data = "紧急";
                className = 'table-status border-red';
                break;
            }

            return h(
              "div", {
              attrs: {
                class: className
              }
            },
              data
            )
          }
        },
        {
          key: "machineName",
          title: "机器",
          align: "center",
          width: 180,
        },
        {
          key: "operateTime",
          title: "时间",
          align: "center",
          width: 200,
        },
        {
          key: "operator",
          title: "拼版人",
          align: "center",
          width: 200,
        },
        {
          title: "操作",
          key: "action",
          width: 300,
          align: "center",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "button", {
                  style: {
                                          marginRight: "10px",
                                          display:"inline",
                                          cursor: 'pointer',
                                          padding:"2px 6px",
                                          background:'#326CFB',
                                          color:"white",
                                          // borderRadio:'5px',
                                          border:"none",
                                        },
                on: {
                  click: () => { //修改状态
                    this.editStatusOne(params.row);
                  }
                }
              },
                "修改"
              ),
              h(
                "button", {
                  style: {
                                          marginRight: "10px",
                                          display:"inline",
                                          cursor: 'pointer',
                                          padding:"2px 6px",
                                          background:'#FF9900',
                                          color:"white",
                                          // borderRadio:'5px',
                                          border:"none",
                                        },
                on: {
                  click: () => { //修改状态
                    this.$router.push({
                      name: "fenGAdd"
                    });
                    window.sessionStorage.setItem("objFenge", JSON.stringify(params.row));
                  }
                }
              },
                "分割"
              ),
              // h(
              //   "button", {
              //     style: {
              //       marginRight: "10px",
              //                             display:"inline",
              //                             cursor: 'pointer',
              //                             padding:"2px 6px",
              //                             background:'#5E5DFE',
              //                             color:"white",
              //                             // borderRadio:'5px',
              //                             border:"none",
              //                           },
              //   on: {
              //     click: () => { //修改状态
              //       this.printRows(params.row);
              //     }
              //   }
              // },
              //   "贴标"
              // ),
              h(
                "button", {
                  style: {
                          marginRight: "10px",
                          display:"inline",
                          cursor: 'pointer',
                          padding:"2px 6px",
                          background:'rgb(253, 90, 91)',
                          color:"white",
                          // borderRadio:'5px',
                          border:"none",
                      },
                on: {
                  click: () => { //修改状态
                    this.$Modal.confirm({
                title: "确认",
                content: "是否确认删除?",
                onOk: () => {
                  cutCommonDelete({
                    id:params.row.id,
                    type:2,
                  }).then( res => {
                    if(res.code == 200){
                      this.searchBtnSplit()
                      this.$Message.success('删除成功！');
                    }
                  })
                }
              });
                  }
                }
              },
                "删除"
              ),
              h(
                "button", {
                  style: {
                          marginRight: "10px",
                          display:"inline",
                          cursor: 'pointer',
                          padding:"2px 6px",
                          background:'rgb(60, 212, 151)',
                          color:"white",
                          // borderRadio:'5px',
                          border:"none",
                      },
                on: {
                  click: () => { //修改状态
                    this.$Modal.confirm({
                title: "确认",
                content: "是否确认完成?",
                onOk: () => {
                  cutCommonFulfill({
                    id:params.row.id,
                    type:2,
                  }).then( res => {
                    if(res.code == 200){
                      this.searchBtnSplit()
                      this.$Message.success('操作成功！');
                    }
                  })
                }
              });
                  }
                }
              },
                "完成"
              ),
            ]);
          }
        }
      ],
      tableFhColumnsSlice: [
        {
          title: "序号",
          type: "index",
          width: 70,
          align: "center"
        },
        // {
        //   title: "分割类型",
        //   key: "type",
        //   align: "center",
        //   width: 100,
        // },
        {
          key: "code",
          title: "订/工单编号",
          align: "center",
          width: 250,
        },
        {
          key: "name",
          title: "产品名称",
          width: 320,
          align: "center"
        },
        // {
        //   key: "wide",
        //   title: "物料幅宽(mm)",
        //   align: "center",
        //   width: 100,
        // },
        {
          key: "customer",
          title: "客户名称",
          width: 180,
          align: "center"
        },
        {
          key: "sliceWide",
          title: "裁切宽度(mm)",
          align: "center",
          width: 200,
        },
        {
          key: "sliceLength",
          title: "裁切长度(mm)",
          align: "center",
          width: 200,
          render: (h, params) => {
          return h("span", params.row.sliceLength*1000);
        },
        },
        // {
        //   key: "splitsTotalLength",
        //   title: "分割总长度(m)",
        //   align: "center",
        //   width: 100,
        // },
        {
          key: "sliceNo",
          title: "裁切张数",
          align: "center",
          width: 100,
        },
        // {
        //   key: "unit",
        //   title: "单位",
        //   align: "center",
        //   width: 100,
        // },
        {
            title: "状态",
            key: "status",
            align: "center",
            width: 100,
            render: (h, params) => {
              let data = "";
              let className = '';
              switch (Number(params.row.status)) {
                case 0:
                  data = "未裁切";
                  className = 'table-status border-color-orange';
                  break;
                  case 1:
                  data = "裁切中";
                  className = 'table-status border-color-blue';
                  break;
                case 2:
                  data = "裁切完成";
                  className = 'table-status border-light-green';
                  break;
              }

              return h(
                "button", {
                  attrs: {
                    class: className
                  }
                },
                data
              )
            }
          },
        {
          title: "级别",
          key: "level",
          align: "center",
          width: 100,
          render: (h, params) => {
            let data = "";
            let className = '';
            switch (Number(params.row.level)) {
              case 1:
                data = "正常";
                className = 'table-status  border-color-blue';
                break;
              case 2:
                data = "紧急";
                className = 'table-status border-red';
                break;
            }

            return h(
              "div", {
              attrs: {
                class: className
              }
            },
              data
            )
          }
        },
        // {
        //   key: "operateTime",
        //   title: "裁切时间",
        //   align: "center",
        //   width: 200,
        // },
        // {
        //   key: "operator",
        //   title: "裁切人",
        //   align: "center",
        //   width: 200,
        // },
        {
          key: "machineName",
          title: "机器",
          align: "center",
          width: 180,
        },
        {
          key: "operateTime",
          title: "操作时间",
          align: "center",
          width: 200,
        },
        // {
        //   key: "operator",
        //   title: "拼版人",
        //   align: "center",
        //   width: 200,
        // },
        {
          title: "操作",
          key: "action",
          width: 300,
          align: "center",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "button", {
                  style: {
                                          marginRight: "10px",
                                          display:"inline",
                                          cursor: 'pointer',
                                          padding:"2px 6px",
                                          background:'#326CFB',
                                          color:"white",
                                          // borderRadio:'5px',
                                          border:"none",
                                        },
                on: {
                  click: () => { //修改状态
                    this.editStatusOne(params.row);
                  }
                }
              },
                "修改"
              ),
              h(
                "button", {
                  style: {
                                          marginRight: "10px",
                                          display:"inline",
                                          cursor: 'pointer',
                                          padding:"2px 6px",
                                          background:'#FF9900',
                                          color:"white",
                                          // borderRadio:'5px',
                                          border:"none",
                                        },
                on: {
                  click: () => { //修改状态
                    this.$router.push({
                      name: "caiQAdd"
                    });
                    window.sessionStorage.setItem("objcaiQ", JSON.stringify(params.row));
                  }
                }
              },
                "裁切"
              ),
              // h(
              //   "button", {
              //     style: {
              //       marginRight: "10px",
              //                             display:"inline",
              //                             cursor: 'pointer',
              //                             padding:"2px 6px",
              //                             background:'#5E5DFE',
              //                             color:"white",
              //                             // borderRadio:'5px',
              //                             border:"none",
              //                           },
              //   on: {
              //     click: () => { //修改状态
              //       this.printRowss(params.row);
              //     }
              //   }
              // },
              //   "贴标"
              // ),
              h(
                "button", {
                  style: {
                          marginRight: "10px",
                          display:"inline",
                          cursor: 'pointer',
                          padding:"2px 6px",
                          background:'rgb(253, 90, 91)',
                          color:"white",
                          // borderRadio:'5px',
                          border:"none",
                      },
                on: {
                  click: () => { //修改状态
                    this.$Modal.confirm({
                title: "确认",
                content: "是否确认删除?",
                onOk: () => {
                  cutCommonDelete({
                    id:params.row.id,
                    type:3,
                  }).then( res => {
                    if(res.code == 200){
                      this.searchBtnSlice()
                      this.$Message.success('删除成功！');
                    }
                  })
                }
              });
                  }
                }
              },
                "删除"
              ),
              h(
                "button", {
                  style: {
                          marginRight: "10px",
                          display:"inline",
                          cursor: 'pointer',
                          padding:"2px 6px",
                          background:'rgb(60, 212, 151)',
                          color:"white",
                          // borderRadio:'5px',
                          border:"none",
                      },
                on: {
                  click: () => { //修改状态
                    this.$Modal.confirm({
                title: "确认",
                content: "是否确认完成?",
                onOk: () => {
                  cutCommonFulfill({
                    id:params.row.id,
                    type:3,
                  }).then( res => {
                    if(res.code == 200){
                      this.searchBtnSlice()
                      this.$Message.success('操作成功！');
                    }
                  })
                }
              });
                  }
                }
              },
                "完成"
              ),
            ]);
          }
        }
      ],
      tableFhColumnsPackAge: [
      {
                        type: 'expand',
                        width: 60,
                        align: 'center',
                        render: (h, params) => {
                        let that = this;
                        return h(bigBoardExpandRow, {
                            props: {
                            bigBoardData: params.row.bigBoardData || [],
                            sendType:1
                            }
                        })
                        }
                    },
      {
          title: "序号",
          type: "index",
          width: 70,
          align: "center"
        },
        // {
        //   title: "分割类型",
        //   key: "type",
        //   align: "center",
        //   width: 100,
        // },
        {
          key: "code",
          title: "订单编号",
          align: "center",
          width: 200,
        },
        {
          key: "customer",
          title: "公司名称",
          width: 250,
          align: "center"
        },
        {
          key: "name",
          title: "物料名称",
          width: 290,
          align: "center"
        },
        // {
        //   key: "wide",
        //   title: "物料幅宽(mm)",
        //   align: "center",
        //   width: 100,
        // },
        {
          key: "size",
          title: "规格",
          align: "center",
          width: 200,
        },
        {
          key: "orderNum",
          title: "订单数量",
          align: "center",
          width: 200,
        },
        // {
        //   key: "splitsTotalLength",
        //   title: "分割总长度(m)",
        //   align: "center",
        //   width: 100,
        // },
        {
          key: "fulfillOrderNum",
          title: "生产数量",
          align: "center",
          width: 200,
        },
        {
          key: "unit",
          title: "单位",
          align: "center",
          width: 100,
        },
        {
            title: "状态",
            key: "status",
            align: "center",
            width: 100,
            render: (h, params) => {
              let data = "";
              let className = '';
              switch (Number(params.row.status)) {
                case 0:
                  data = "未打包";
                  className = 'table-status border-color-orange';
                  break;
                case 2:
                  data = "打包完成";
                  className = 'table-status border-light-green';
                  break;
              }

              return h(
                "button", {
                  attrs: {
                    class: className
                  }
                },
                data
              )
            }
          },
        // {
        //   title: "级别",
        //   key: "level",
        //   align: "center",
        //   width: 100,
        //   render: (h, params) => {
        //     let data = "";
        //     let className = '';
        //     switch (Number(params.row.level)) {
        //       case 1:
        //         data = "正常";
        //         className = 'table-status  border-color-blue';
        //         break;
        //       case 2:
        //         data = "紧急";
        //         className = 'table-status border-light-red';
        //         break;
        //     }

        //     return h(
        //       "div", {
        //       attrs: {
        //         class: className
        //       }
        //     },
        //       data
        //     )
        //   }
        // },
        {
          title: "操作",
          key: "action",
          width: 200,
          align: "center",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
            h(
                "button", {
                  style: {
                                          marginRight: "10px",
                                          display:"inline",
                                          cursor: 'pointer',
                                          padding:"2px 6px",
                                          background:'#326CFB',
                                          color:"white",
                                          // borderRadio:'5px',
                                          border:"none",
                                        },
                on: {
                  click: () => { //修改状态
                   this.packModalFlag = true
                   this.packAgeObj = params.row
                   this.sumNumber = 0
                   this.paperNumber = 0
                   this.ballNumber = 0
                   this.getGoodsListFun()
                  }
                }
              },
                "打包"
              ),
              h(
                "button", {
                  style: {
                                          marginRight: "10px",
                                          display:"inline",
                                          cursor: 'pointer',
                                          padding:"2px 6px",
                                          background:'#FF9900',
                                          color:"white",
                                          // borderRadio:'5px',
                                          border:"none",
                                        },
                on: {
                  click: () => { //修改状态
                    this.printRow(params.row);
                  }
                }
              },
                "贴标"
              ),
              h(
                "button", {
                  style: {
                    marginTop:'5px',
                          marginRight: "10px",
                          display:"inline",
                          cursor: 'pointer',
                          padding:"2px 6px",
                          background:'rgb(60, 212, 151)',
                          color:"white",
                          // borderRadio:'5px',
                          border:"none",
                      },
                on: {
                  click: () => { //修改状态
                    this.$Modal.confirm({
                title: "确认",
                content: "是否确认完成?",
                onOk: () => {
                  cutCommonFulfill({
                    id:params.row.id,
                    type:4,
                  }).then( res => {
                    if(res.code == 200){
                      this.searchBtnPackAge()
                      this.$Message.success('操作成功！');
                    }
                  })
                }
              });
                  }
                }
              },
                "完 成"
              ),
            ]);
          }
        }
      ],
      tableFgColumns: [{
        type: 'selection',
        align: 'center',
      },
      {
        title: "序号",
        type: "index",
        align: "center"
      },
      {
        key: "partNo",
        title: "工单编号",
        align: "center",
      },
      // {
      //   key: "orderNo",
      //   title: "订单号",
      //   align: "center",
      // },
      {
        key: "productName",
        title: "产品名称",
        align: "center"
      },
      {
        key: "companyName",
        title: "公司名称",
        align: "center"
      },
      {
        key: "pbCount",
        title: "卷数",
        align: "center"
      },
      {
        key: "productWidth",
        title: "宽度",
        align: "center",
      },
      {
        key: "pbWidth",
        title: "拼版宽度",
        align: "center",
      },
      {
        key: "pbLength",
        title: "拼版长度",
        align: "center",
      },
      {
        key: "area",
        title: "面积",
        align: "center",
      },
      {
        title: "生产状态",
        key: "type",
        align: "center",
        width: 100,
        render: (h, params) => {
          let data = "";
          let className = '';
          switch (Number(params.row.type)) {
            case 1:
              data = "待复合";
              className = 'table-status  border-color-blue';
              break;
            case 2:
              data = "待拼版";
              className = 'table-status border-light-green';
              break;
            case 3:
              data = "待分割";
              className = 'table-status border-color-orange';
              break;
            case 4:
              data = "待裁切";
              className = 'table-status border-color-purple';
              break;
            case 5:
              data = "成品";
              className = 'table-status border-color-blue';
              break;
            case 6:
              data = "已取消";
              className = 'table-status border-red';
              break;
          }

          return h(
            "button", {
            attrs: {
              class: className
            }
          },
            data
          )
        }
      },
      {
        title: "操作",
        key: "action",
        width: 150,
        align: "center",
        render: (h, params) => {
          return h("div", [
            h(
              "div", {
              class: {
                'iconfont table-shengchan table-button-div color-blue': true
              },
              domProps: {
                title: '操作'
              },
              on: {
                click: () => { //编辑
                  this.editRow(params.row);
                }
              }
            },
              ""
            ),
            h(
              "div", {
              class: {
                'iconfont table-edit table-button-div color-blue': true
              },
              domProps: {
                title: '修改状态'
              },
              on: {
                click: () => { //修改状态
                  this.editStatus(params.row);
                }
              }
            },
              ""
            ),
            h(
              "div", {
              class: {
                'iconfont table-waixie table-button-div color-blue': true
              },
              domProps: {
                title: '切换设备'
              },
              on: {
                click: () => { //修改状态
                  this.changeEquipFlag = true;
                  this.equipForm.equipId = this.activeEquip;
                  this.equipForm.partNo = params.row.partNo;
                }
              }
            },
              ""
            ),
          ]);
          //changeEquip
        }
      }
      ],

      tableColumns: [{
        type: 'selection',
        align: 'center',
      },
      {
        title: "序号",
        type: "index",
        align: "center"
      },
      {
        key: "partNo",
        title: "工单编号",
        align: "center",
      },
      {
        key: "orderNo",
        title: "订单号",
        align: "center",
      },
      {
        key: "productName",
        title: "产品名称",
        align: "center"
      },
      {
        key: "companyName",
        title: "公司名称",
        align: "center"
      },
      // {
      //   key: "orderCount",
      //   title: "订单数量",
      //   width: 100,
      //   align: "center",
      //   render: (h, params) => {
      //     var data = params.row.orderCount;
      //     if (params.row.type == 1) { //复合
      //       data = params.row.area + "平方米";
      //     }

      //     return h("span", data);
      //   }
      // },
      {
        key: "count",
        title: "工单数量",
        align: "center",
        render: (h, params) => {
          var data = params.row.count;
          if (params.row.type == 1) { //复合
            data = params.row.area + "平方米";
          }

          return h("span", data);
        }
      },

      {
        key: "productWidth",
        title: "宽度",
        align: "center",
        render: (h, params) => {
          return h("span", params.row.productWidth + "*" + params.row.productLength);
        }
      },
      // {
      //   key: "productLength",
      //   title: "长度",
      //   align: "center",
      // },
      {
        key: "area",
        title: "面积",
        align: "center",
      },
      {
        key: "unit",
        title: "单位",
        align: "center",
      },
      // {
      //   key: "orderTime",
      //   title: "出货时间",
      //   align: "center",
      //   width: 170,
      // },
      {
        title: "生产状态",
        key: "type",
        align: "center",
        render: (h, params) => {
          let data = "";
          let className = '';
          switch (Number(params.row.type)) {
            case 1:
              data = "待复合";
              className = 'table-status  border-color-blue';
              break;
            case 2:
              data = "待拼版";
              className = 'table-status border-light-green';
              break;
            case 3:
              data = "待分割";
              className = 'table-status border-color-orange';
              break;
            case 4:
              data = "待裁切";
              className = 'table-status border-color-purple';
              break;
            case 5:
              data = "成品";
              className = 'table-status border-color-blue';
              break;
            case 6:
              data = "已取消";
              className = 'table-status border-red';
              break;
          }

          return h(
            "button", {
            attrs: {
              class: className
            }
          },
            data
          )
        }
      },
      // {
      //   title: "生产进度",
      //   key: "processList",
      //   align: "center",
      //   slot: 'processList'
      // },
      {
        key: "pbPartNo",
        title: "版号",
        align: "center",
      },
      {
        title: "操作",
        key: "action",
        width: 150,
        align: "center",
        render: (h, params) => {
          return h("div", [
            h(
              "div", {
              class: {
                'iconfont table-shengchan table-button-div color-blue': true
              },
              domProps: {
                title: '操作'
              },
              on: {
                click: () => { //编辑
                  this.editRow(params.row);
                }
              }
            },
              ""
            ),
            h(
              "div", {
              class: {
                'iconfont table-edit table-button-div color-blue': true
              },
              domProps: {
                title: '修改状态'
              },
              on: {
                click: () => { //修改状态
                  this.editStatus(params.row);
                }
              }
            },
              ""
            ),
            h(
              "div", {
              class: {
                'iconfont table-waixie table-button-div color-blue': true
              },
              domProps: {
                title: '切换设备'
              },
              on: {
                click: () => { //修改状态
                  this.changeEquipFlag = true;
                  this.equipForm.equipId = this.activeEquip;
                  this.equipForm.partNo = params.row.partNo;
                }
              }
            },
              ""
            ),
          ]);
          //changeEquip
        }
      }
      ],
      loading: false,
      loadingSplit: false,
      loadingSlice:false,
      processData: [],
      tableDataSlice:[],
      equipData: [],
      backPaperData: [],
      backPaperColumns: [{
        title: "序号",
        type: "index",
        width: 70,
        align: "center"
      },
      {
        key: "goodsName",
        title: "名称",
        align: "center",
        width: 150,
        slot: 'goodsName'
      },
      {
        key: "goodsNo",
        title: "序列号",
        slot: 'goodsNo',
        align: "center",
        width: 200,
      },
      {
        key: "oriWeight",
        title: "重量(kg)",
        align: "center",
        width: 100,
      },
      {
        key: "remainWeight",
        title: "退库(kg)",
        slot: 'remainWeight',
        align: "center",
        width: 130,
      },
      {
        key: "specification",
        title: "规格",
        align: "center",
        width: 100,
      },
      {
        key: "weightLoss",
        title: "报损(kg)",
        slot: 'weightLoss',
        align: "center",
        width: 120,
      },
      {
        title: "操作",
        key: "action",
        align: "center",
        render: (h, params) => {
          return h("div", [
            h(
              "div", {
              class: {
                'iconfont table-agree table-button-div color-blue': true
              },
              domProps: {
                title: '保存'
              },
              on: {
                click: () => { //编辑
                  //console.log(params.row)
                  this.saveRow(params.row);
                }
              }
            },
              ""
            ),
            h(
              "div", {
              class: {
                'iconfont table-print table-button-div color-orange': true
              },
              domProps: {
                title: '打印标签'
              },
              on: {
                click: () => { //修改状态
                  // console.log(params.row)
                  this.printSourceRow(params.row);

                  // this.editStatus(params.row);
                }
              }
            },
              ""
            ),
            h(
              "div", {
              class: {
                'iconfont table-delete table-button-div color-light-red': true
              },
              domProps: {
                title: '删除'
              },
              on: {
                click: () => { //编辑

                  deleteGoodsSource({
                    goodsNo: params.row.goodsNo
                  })
                    .then(res => {
                      if (res.code == 200) {
                        this.getOneDetail();
                      }
                    })
                }
              }
            },
              ""
            ),
          ]);
        }
      }
      ],
      selectedObj: {},
      partNoDetail: {},
      numCountObj: {},
      facialData: [],
      facialColumns: [{
        title: "序号",
        type: "index",
        width: 70,
        align: "center"
      },
      {
        key: "goodsName",
        title: "名称",
        align: "center",
        width: 150,
        slot: 'goodsName'
      },
      {
        key: "goodsNo",
        title: "序列号",
        slot: 'goodsNo',
        align: "center",
        width: 200,
      },
      {
        key: "oriWeight",
        title: "重量(kg)",
        align: "center",
        width: 100,
      },
      {
        key: "remainWeight",
        title: "退库(kg)",
        slot: 'remainWeight',
        align: "center",
        width: 130,
      },
      {
        key: "specification",
        title: "规格",
        align: "center",
        width: 100,
      },
      {
        key: "weightLoss",
        title: "报损(kg)",
        slot: 'weightLoss',
        align: "center",
        width: 120,
      },
      {
        title: "操作",
        key: "action",
        align: "center",

        render: (h, params) => {
          return h("div", [
            h(
              "div", {
              class: {
                'iconfont table-agree table-button-div color-blue': true
              },
              domProps: {
                title: '保存'
              },
              on: {
                click: () => { //编辑
                  this.saveRow(params.row);
                }
              }
            },
              ""
            ),
            h(
              "div", {
              class: {
                'iconfont table-print table-button-div color-orange': true
              },
              domProps: {
                title: '打印标签'
              },
              on: {
                click: () => { //修改状态
                  this.printSourceRow(params.row);
                }
              }
            },
              ""
            ),
            h(
              "div", {
              class: {
                'iconfont table-delete table-button-div color-light-red': true
              },
              domProps: {
                title: '删除'
              },
              on: {
                click: () => { //编辑
                  deleteGoodsSource({
                    goodsNo: params.row.goodsNo
                  })
                    .then(res => {
                      if (res.code == 200) {
                        this.getOneDetail();
                      }
                    })
                }
              }
            },
              ""
            ),
          ]);
        }
      }
      ],
      glueData: [],
      glueColumns: [{
        title: "序号",
        type: "index",
        width: 70,
        align: "center"
      },
      {
        key: "goodsName",
        title: "名称",
        align: "center",
        width: 150,
        slot: 'goodsName'
      },
      {
        key: "goodsNo",
        title: "序列号",
        slot: 'goodsNo',
        align: "center",
        width: 200,
      },
      {
        key: "oriWeight",
        title: "重量(kg)",
        align: "center",
        width: 100,
      },
      {
        key: "remainWeight",
        title: "退库(kg)",
        slot: 'remainWeight',
        align: "center",
        width: 130,
      },
      {
        key: "specification",
        title: "规格",
        align: "center",
        width: 100,
      },
      {
        key: "weightLoss",
        title: "报损(kg)",
        slot: 'weightLoss',
        align: "center",
        width: 120,
      },
      {
        title: "操作",
        key: "action",
        align: "center",
        render: (h, params) => {
          return h("div", [
            h(
              "div", {
              class: {
                'iconfont table-agree table-button-div color-blue': true
              },
              domProps: {
                title: '保存'
              },
              on: {
                click: () => { //编辑
                  this.saveRow(params.row);
                }
              }
            },
              ""
            ),
            h(
              "div", {
              class: {
                'iconfont table-print table-button-div color-orange': true
              },
              domProps: {
                title: '打印标签'
              },
              on: {
                click: () => { //修改状态
                  this.printSourceRow(params.row);
                }
              }
            },
              ""
            ),
            h(
              "div", {
              class: {
                'iconfont table-delete table-button-div color-light-red': true
              },
              domProps: {
                title: '删除'
              },
              on: {
                click: () => { //编辑
                  deleteGoodsSource({
                    goodsNo: params.row.goodsNo
                  })
                    .then(res => {
                      if (res.code == 200) {
                        this.getOneDetail();
                      }
                    })
                }
              }
            },
              ""
            ),
          ]);
        }
      }
      ],
      proId: '',
      intervalTime: null,
      selectedRow: {},
      proSelectModal: false,
      proSelectModals: false,
      pageNum: 1,
      pageSize: 15,
      total: 0,
      pageNumSplit: 1,
      pageSizeSplit: 15,
      totalSplit: 0,
      pageNumSlice: 1,
      pageSizeSlice: 15,
      totalSlice: 0,
      searchFormPackAge:{
        status:'0'
      },
      pageNumPackAge: 1,
      pageSizePackAge: 15,
      totalPackAge: 0,
      pageNumPackAgesss: 1,
      pageSizePackAgesss: 10,
      totalPackAgesss: 0,
      tableDataPackAge:[],
      loadingPackAge:false,
      packAgeObj:{},
    }
  },
  methods: {
    choseSplit(v){
      console.log("44444",v)
      
      this.processData.map( item => {
        console.log("5555",item);
        if((item.id).toString() === v){
          this.searchFormSplit.machineName = item.name
        }
      })
      console.log("this.searchFormSplit",this.searchFormSplit);
    },
    getGoodsListFun(){
      let params = {
        data:{
          ...this.searchFormPackAgess,
          wide:this.packAgeObj.wide,
          length:this.packAgeObj.length,
          productId:this.packAgeObj.productId,
          id:this.packAgeObj.id,
        },
        pageNum:this.pageNumPackAgesss,
        pageSize:this.pageSizePackAgesss,
      }
      getGoodsList(params).then( res => {
        if(res.code == 200){
          let data = res.data.records
          data.map( item => {
            if(item.unit == "张"){
              item.useNo = item.num
            }else{
              item.useNo = item.remLen
            }
          })
          this.packageAddGoodsData = data
          this.totalPackAgesss = res.data.total
        }
      })
    },
    onExpand2(row,status){
      console.log("status",status);
        let index = this.$refs.packAgeTab.data.findIndex(item => item.id == row.id)
        if(status){
          // if(!row.bigBoardData){
           let params = {
            pId : row.id,
            };
            // let obj = row;
            getChildPackageList(params)
            .then(res => {
              if(res.code == 200){
                let arr = res.data ? res.data : []
                arr.forEach(item => {
                    item._disabled = true
                })
                this.$set(this.$refs.packAgeTab.data[index],'bigBoardData',arr);
                this.tableDataPackAge[index]['_expanded'] = true;
              }
            })
          // }
        } else {
          this.tableDataPackAge[index]['_expanded'] = false;
        }

      },
      selectTab(v) {
        const data = this.$refs.DdbPackRefss.getSelection();
        // this.selectedRows = this.$refs.DdbPackRefss.getSelection();
      
        if (data.length === 0) {
          // this.$Message.warning('请勾选数据！');
          return
        }
        let number = 0
        data.map( item => {
          number+=item.useNo
        })
        this.sumNumber = number
        if(!!this.paperNumber){
          this.ballNumber = Math.floor(number/this.paperNumber)
        }

      },
      getVal(v){
        console.log("22",v)
        if(!!this.sumNumber){
          this.ballNumber =  Math.floor(this.sumNumber/this.paperNumber)
        }
      },
      printRows(v){
        let params = {
          id : v.id
        }
        cutPaperPDF(params)
                    .then(res =>{
                         if(res.code == 200){
                             window.open(res.data.result,"_blank");
                         }
                    })
            },
            printRowss(v){
        let params = {
          id : v.id
        }
        cutPaperSlicePDF(params)
                    .then(res =>{
                         if(res.code == 200){
                             window.open(res.data.result,"_blank");
                         }
                    })
            },
      printRow(v){
        let params = {
          id : v.id
        }
        packageDecals(params)
                    .then(res =>{
                         if(res.code == 200){
                             window.open(res.data.result,"_blank");
                         }
                    })
            },
    handleSummaryGoodsPackage({
      columns,
      data
    }) {
      const sums = {};
      columns.forEach((column, index) => {

        const key = column.key;
        if (index === 0) {
          sums[key] = {
            key,
            value: '合计'
          };
          return;
        }
        const values = data.map(item => Number(item[key]));
        if (!values.every(value => isNaN(value))) {
          const v = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          if (key === 'batchNum') {
            sums[key] = {
              key,
              value: v
            };
          } else {
            sums[key] = {
              key,
              value: ''
            };
          }
        } else {
          sums[key] = {
            key,
            value: ''
          };
        }
      });

      return sums;
    },
    handleSummary3({
      columns,
      data
    }) {
      const sums = {};
      columns.forEach((column, index) => {
        const key = column.key;
        if (index === 0) {
          sums[key] = {
            key,
            value: '合计'
          };
          return;
        }
        const values = data.map(item => Number(item[key]));
        if (!values.every(value => isNaN(value))) {
          const v = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          if (key === 'remainLength' || key === 'useLength' || key === 'joint') {
            sums[key] = {
              key,
              value: v
            };
          } else {
            sums[key] = {
              key,
              value: ''
            };
          }

        } else {
          sums[key] = {
            key,
            value: ''
          };
        }
      });

      return sums;
    },
    handleSummaryCq({
      columns,
      data
    }) {
      const sums = {};
      columns.forEach((column, index) => {
        const key = column.key;
        if (index === 0) {
          sums[key] = {
            key,
            value: '合计'
          };
          return;
        }
        const values = data.map(item => Number(item[key]));
        if (!values.every(value => isNaN(value))) {
          const v = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          if (key === 'num') {
            sums[key] = {
              key,
              value: v
            };
          } else {
            sums[key] = {
              key,
              value: ''
            };
          }

        } else {
          sums[key] = {
            key,
            value: ''
          };
        }
      });

      return sums;
    },
    saveFgRow() {
      let params = {
        list: this.saveAllFgRowList,
        pbPartNo: this.fgOriGoods.pbPartNo
      }
      saveUseFgGoods(params)
        .then(res => {
          if (res.code == 200) {
            console.log(123);
            this.$Message.success('保存成功！');
            this.getOneDetail();
            this.saveAllFgRowList = [];
          }
        })
    },
    saveFgLength(v) {
      let params = {
        id: v.id,
        productLength: v.remainLength,
        joint: v.joint
      }
      modyFgOriGoodsLength(params)
        .then(res => {
          if (res.code == 200) {

          }
        })
    },
    
    saveFgUseLength(v) {
      console.log(this.cutData)
      // if(!v.useLength){
      //   return;
      // }
      let data = {
        id: v.id,
        useLength: v.useLength,
        joint: v.joint
      }

      if (this.saveAllFgRowList.length <= 0) {
        this.saveAllFgRowList.push(data)
        console.log(this.saveAllFgRowList)
        return
      } else {
        for (let i = 0; i < this.saveAllFgRowList.length; i++) {
          if (this.saveAllFgRowList[i].id == data.id) {
            if (!data.useLength) {
              this.saveAllFgRowList.splice(i, 1);
              console.log(this.saveAllFgRowList)
              return;
            }
            this.saveAllFgRowList[i].useLength = data.useLength;
            this.saveAllFgRowList[i].joint = data.joint;
            console.log(this.saveAllFgRowList)
            return;
          }
        }
        this.saveAllFgRowList.push(data)
        console.log(this.saveAllFgRowList)
      }

    },
    sureProBtn() {
      const data = this.$refs.proSelectTab.getSelection();
      if (data.length === 0) {
        this.$Message.warning('请勾选数据！');
        return
      }
      let params = {
        list: data.map(item => item.goodsNo),
        partNo: this.selectedObj.partNo,
      }
      chooseFgGoods(params)
        .then(res => {
          if (res.code == 200) {
            this.$Message.success('保存成功！');
            this.proSelectModals = false
            this.getOneDetail()
          }
        })
    },
    sureProBtnTwo() {
      const data = this.$refs.proSelectTabTwo.getSelection();
      if (data.length === 0) {
        this.$Message.warning('请勾选数据！');
        return
      }
      let params = {
        list: data.map(item => item.goodsNo),
        partNo: this.selectedObj.partNo,
      }
      console.log(params);
      chooseCqGoods(params)
        .then(res => {
          if (res.code == 200) {
            this.$Message.success('保存成功！');
            this.proSelectModal = false
            this.getOneDetail()
          }
        })
    },
    addProductBtn() {
      if (!this.proSelectModals) {
        this.proSelectModals = true;
      }
      this.proSelectData = [];
      this.proSelectForm = {
        width: this.partNoDetail.productWidth,
        maxWidth: this.partNoDetail.productWidth
      };
      this.findStoreGoodsList();
    },
    getProductList() {
      getNoPasteProNameList().then( res => {
        if(res.code == 200){
          this.productList = res.data
        }
      })
    },
    getProductListFg() {
      getNoSplitsProNameList().then( res => {
        if(res.code == 200){
          this.productList = res.data
        }
      })
    },
    getProductListCq() {
      getNoSliceProNameList().then( res => {
        if(res.code == 200){
          this.productList = res.data
        }
      })
    },
    getProductListDb() {
      getNoPackageProNameList().then( res => {
        if(res.code == 200){
          this.productList = res.data
        }
      })
    },
    handleChangePage(page) {
      this.pageNum = page;
      this.searchData();
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.searchData();
    },
    handleChangePagePackAge(page) {
      this.pageNumPackAge = page;
      this.searchDataPackAge();
    },
    handlePageSizeChangePackAge(size) {
      this.pageSizePackAge = size;
      this.searchDataPackAge();
    },
    handleChangePagePackAgesss(page) {
      this.pageNumPackAgesss = page;
      this.getGoodsListFun();
    },
    handlePageSizeChangePackAgesss(size) {
      this.pageSizePackAgesss = size;
      this.getGoodsListFun();
    },
    handleChangePageSplit(page) {
      this.pageNumSplit = page;
      this.searchDataSplit();
    },
    handlePageSizeChangeSplit(size) {
      this.pageSizeSplit = size;
      this.searchDataSplit();
    },
    handleChangePageSlice(page) {
      this.pageNumSlice = page;
      this.searchDataSlice();
    },
    handlePageSizeChangeSlice(size) {
      this.pageSizeSlice = size;
      this.searchDataSlice();
    },
    findStoreGoodsList() {
      //let types = this.proSelectForm.types;

      findGoodsList({
        productId: this.partNoDetail.productId,
        width: this.proSelectForm.width,
        maxWidth: this.proSelectForm.maxWidth,
        encode: this.proSelectForm.encode ? this.proSelectForm.encode : "",
        type: this.proSelectForm.type
      })
        .then(res => {
          console.log(res);
          if (res.code == 200) {
            console.log(res.data);
            this.proSelectData = res.data;
          }
        })
    },
    revokeBtn() { //撤销物料使用

      var that = this;
      let params = {
        partNo: this.selectedObj.partNo,
        type: this.selectedObj.type,
      }
      this.$Modal.confirm({
        title: "撤销工序",
        content: "是否撤销当前工序（确认后会撤销当前工序所有的数据回归初始工序状态）?",
        onOk: () => {
          revokeOrder(params)
            .then(res => {
              console.log(res);
              that.$Message.success(res.message);
              if (res.code == 200) {
                that.getOneDetail();
              }
            })

        }
      });




    },
    addProductBtnTwo() {
      this.proSelectModal = true;
      let minWidth = this.selectedObj.productWidth > this.selectedObj.productLength ? this.selectedObj.productLength :
        this.selectedObj.productWidth;
      let maxWidth = minWidth;

      this.proSelectForm = {
        width: minWidth,
        maxWidth: maxWidth
      };
      this.findStoreCqGoodsList();
    },
    getCustomerListFun(){
      getCustomerList().then(res => {
        if(res.code == 200){
          this.customerList = res.data

        }
      })
    },
    getCustomerListSliceFun(){
      getCustomerListSlice().then(res => {
        if(res.code == 200){
          this.customerList = res.data

        }
      })
    },
    
    findStoreCqGoodsList() {
      let params = {
        productId: parseInt(this.selectedObj.productId),
        width: this.proSelectForm.width,
        maxWidth: this.proSelectForm.maxWidth,
        encode: this.proSelectForm.encode ? this.proSelectForm.encode : "",
        type: this.proSelectForm.type
      }
      this.proSelectDataTwo = [];
      findGoodsList(params)
        .then(res => {
          this.proSelectDataTwo = res.data
        })
    },
    addPackageProductBtn() { //添加打包需要的半成品信息
      this.proPackageSelectModal = true;
      this.proSelectForm = {
        productId: parseInt(this.selectedObj.productId),
        width: this.selectedObj.productWidth,
        length: this.selectedObj.productLength,
        unit: this.selectedObj.unit,
        goodsType: this.selectedObj.unit == '卷' ? 2 : 3
      };
      this.getPackageProductList();
    },
    savePackageGoodsBtn() { //保存选择的打包的产品
      const data = this.$refs.proPackageSaveTab.getSelection();
      if (data.length === 0) {
        this.$Message.warning('请勾选数据！');
        return
      }
      savePackageGoods(data)
        .then(res => {
          this.$Message.success('打包成功！');
          this.getOneDetail()
        })

    },
    
    getPackageProductList() {
      this.packageSelectGoodsData = [];
      // var param = {
      //   this.proSelectForm..
      // }

      console.log(this.proSelectForm)
      findGoodsList({
        productId: this.partNoDetail.productId,
        width: this.proSelectForm.width,
        maxWidth: this.proSelectForm.maxWidth,
        encode: this.proSelectForm.encode ? this.proSelectForm.encode : "",
        length: this.proSelectForm.length
      })
        .then(res => {
          this.packageSelectGoodsData = res.data
        })
    },
    surePackageProBtn() { //确认选择对应的产品作为打包产品
      const data = this.$refs.proPackageSelectTab.getSelection();
      if (data.length === 0) {
        this.$Message.warning('请勾选数据！');
        return
      }
      var params = new Array;
      for (var i in data) {
        data[i].orderNo = this.selectedObj.orderNo;
        // params.push({
        //   orderNo: this.selectedObj.orderNo,
        //   goodsType: this.proSelectForm.goodsType,
        //   goodsNo: data[i].goodsNo
        // });
      }
      // console.log(params)
      addPackageGoods(data)
        .then(res => {
          if (res.code == 200) {
            this.$Message.success('选择成功！');
            this.proPackageSelectModal = false
            this.getOneDetail()
          }
        })


    },
    editStatus(v) {
      this.updateModalFlag = true;
      this.selectedRow = {
        ...v
      };
      this.newStatus = ''
    },
    editStatusOne(v) {
      console.log("22222",v);
      this.updateModalFlagOne = true;
      this.selectedRow = {
        ...v,
        level:(v.level).toString()
      };
      // this.newStatus = ''
    },
    editEquip(v) {
      this.updateModalFlag = true;
      // this.selectedRow = {
      //   ...v
      // };
      // this.newStatus = ''
    },
    submitUpdate() {
      let params = {
        ...this.selectedRow,
        type:this.activeTab == 0? 0 :this.activeTab == 2?2:this.activeTab == 3?3:'',
        machine:!!this.selectedRow.machineName? this.selectedRow.machineName:''
      }
      delete params.machineName
      cutCommonUpdate(params)
        .then(res => {
          if (res.code == 200) {
            this.$Message.success('修改成功！');
            this.updateModalFlagOne = false;
            if (this.activeTab == 0) {
              this.searchData()
            } else if (this.activeTab == 2) {
              this.searchBtnSplit()
            } else if (this.activeTab == 3) {
              this.searchBtnSlice()
            }
          }
        })
    },
    printSourceRow(v) {
      console.log(v)
      getPrintSource({
        goodsNo: v.goodsNo
      })
        .then(res => {
          if (res.code == 200) {
            var data = res.data;
            if (data.length) {
              data.length = data.length.toFixed(2)
            }
            if (data.width) {
              data.width = data.width.toFixed(2)
            }



            var params = [{
              carat: data.carat,
              code: data.encode,
              brand: data.brand,
              name: data.name,
              weight: data.weight,
              width: data.width,
              length: data.length,
              areaNum: ((data.width ? data.width : 0) * (data.length ? data.length : 0) / 1000).toFixed(2),
              serial: data.goodsEncode,
              type: '原材料'
            }]
            printPdf(params)
              .then(res1 => {
                if (res1.code == 200) {
                  let path = res1.data.result;
                  let link = document.createElement("a");
                  link.href = path;
                  link.target = "_blank";
                  link.download = path.split("/").pop();
                  link.click();
                }
              })


          }
        })

      // printPdf(params)
      // 	.then(res => {
      // 		if (res.code == 200) {
      // 			let path = res.data.result;
      // 			let link = document.createElement("a");
      // 			link.href = path;
      // 			link.target = "_blank";
      // 			link.download = path.split("/").pop();
      // 			link.click();
      // 		}
      // 	})



    },
    batchPrint() { //批量打印
      //当前订单编号
      var orderNo = this.partNoDetail.orderNo;
      var type = this.selectedObj.type;
      //当前批次
      let data = [];
      if (type == 3) { //分割
        data = this.$refs.fgpackRef.getSelection();
        if (data.length > 0) {
          orderNo = data[0].orderNo
        }
      } else if (type == 4) { //裁切
        data = this.$refs.cqpackRef.getSelection();
      } else { //打包
        data = this.$refs.CpPackRef.getSelection();
      }
      if (data.length === 0) {
        this.$Message.warning('请勾选数据！');
        return;
      }
      var batchNos = new Array;
      for (var i in data) {
        batchNos.push(data[i].batch)
      }

      this.printPackBtn(orderNo, batchNos.join(","));
    },
    printPackBtn(orderNo, batch) {
      //查询对应的需要打包list
      queryPackageListByBatch({
        orderNo: orderNo,
        batchNum: batch
      })
        .then(res => {
          if (res.code == 200) {
            var paramList = new Array;
            for (var i in res.data) {
              var item = res.data[i];
              paramList.push({
                bagNum: item.count,
                bagUnitNum: item.num,
                customer: item.companyName,
                model: item.productSize,
                orderDate: item.createTime,
                orderNo: item.orderNo,
                orderNum: item.orderNum,
                packNo: item.packageNo,
                productName: item.productName,
                productNo: item.goodsNo,
                unit: item.unit
              });
            }

            printPackPDF(paramList)
              .then(res1 => {
                if (res1.code == 200) {
                  let path = res1.data.result;
                  let link = document.createElement("a");
                  link.href = path;
                  link.target = "_blank";
                  link.download = path.split("/").pop();
                  link.click();
                } else {
                  this.$Message.warning(res1.message);
                }
              })
          } else {
            this.$Message.warning(res.message);
          }
        })

      // let params = [{
      //   bagNum: v.count,
      //   bagUnitNum: v.batchNum,
      //   customer: v.companyName,
      //   model: v.productDetail,
      //   orderDate: v.createTime,
      //   orderNo: v.orderNo,
      //   orderNum: v.orderNum,
      //   packNo: v.packageNo,
      //   productName: v.productName,
      //   productNo: v.goodsNo,
      //   unit: v.unit
      // }]
      // printPackPDF(params)
      //   .then(res => {
      //     if (res.code == 200) {
      //       let path = res.data.result;
      //       let link = document.createElement("a");
      //       link.href = path;
      //       link.target = "_blank";
      //       link.download = path.split("/").pop();
      //       link.click();
      //     } else {
      //       this.$Message.warning(res.message);
      //     }
      //   })



    },
    //保存分割
    saveCutBtn() {
      let params = {
        partNo: this.partNoDetail.partNo,
        joint: this.fgOriGoods.newJoint ? this.fgOriGoods.newJoint : ''
      }
      saveCut(params)
        .then(res => {
          if (res.code == 200) {
            this.$Message.success('保存成功！');
            this.getFhTableList(3)
          }
        })

    },
    printDiffWorkBtn() {
      if (this.searchForm.processId == 1) {
        this.printLoading = true;
        const selectedWorks = this.$refs.printTab.getSelection();
        if (selectedWorks.length === 0) {
          this.$Message.warning('请勾选工单！');
          return
        }
        let params = [];
        selectedWorks.forEach(item => {
          params.push(item.partNo);
        });
        printNewFhPaper(params)
          .then(res => {
            if (res.code == 200) {
              let arr = res.data;
              let newArr = [];
              arr.forEach(obj => {
                newArr.push({
                  backPaper: obj.dzName,
                  facePaper: obj.mzName,
                  glue: obj.jsName,
                  square: obj.totalArea,
                  productName: obj.productName,
                  length: obj.productLength,
                  width: obj.productWidth,
                  orderDate: obj.orderTime,
                  workId: obj.partNo
                })
              })
              complexPDF(newArr)
                .then(res => {
                  if (res.code == 200) {
                    let path = res.data.result;
                    let link = document.createElement("a");
                    link.href = path;
                    link.target = "_blank";
                    link.download = path.split("/").pop();
                    link.click();
                  } else {
                    this.$Message.warning(res.message);
                  }
                })

            }
          })
      } else {
        this.printWorkBtn()
      }

    },
    printWorkBtn() {
      //this.printLoading = true;


      const selectedWorks = this.$refs.printTab.getSelection();
      console.log(selectedWorks)
      if (selectedWorks.length === 0) {
        this.$Message.warning('请勾选工单！');
        this.printLoading = false;
        return
      }
      let params = [];
      let pdfName = '';
      if (this.searchForm.processId == 4) {
        pdfName = '裁切';
        selectedWorks.forEach(item => {
          params.push(item.partNo);
        });
        printCqPapers(params)
          .then(res => {
            if (res.code == 200) {
              let paramsArr = res.data;
              let newParams = [];
              paramsArr.forEach(item => {
                newParams.push({
                  workId: item.partNo,
                  deliveryTime: item.deliveryTime,
                  num: item.num,
                  orderNo: item.orderNo,
                  orderTime: item.orderTime,
                  width: item.productWidth,
                  length: item.productLength,
                  unit: item.unit,
                  sequence: '裁切',
                  productName: item.productName,
                  halfProductNos: item.list
                })
              })
              this.printLoading = true;
              printCutPDF(newParams)
                .then(res => {
                  if (res.code == 200) {
                    let path = res.data.result;
                    let link = document.createElement("a");
                    link.href = path;
                    link.target = "_blank";
                    link.download = path.split("/").pop();
                    link.click();
                  } else {
                    this.$Message.warning(res.message);
                  }
                })
            }
          })

      } else if (this.searchForm.processId == 3) {
        pdfName = '分割';
        selectedWorks.forEach(item => {
          params.push(item.pbPartNo)
        })

        printFgPapers(params)
          .then(res => {
            if (res.code == 200) {
              let paramsArr = res.data;
              let newParams = [];
              paramsArr.forEach(item => {
                newParams.push({
                  workId: item.partNo,
                  halfProductNo: item.goodsNo,
                  width: item.productWidth,
                  length: item.productLength / 1000,
                  productName: item.productName,
                  partLength: item.pbLength / 1000,
                  partWidths: item.list
                })
              })
              this.printLoading = true;
              partingPDF(newParams)
                .then(res => {
                  if (res.code == 200) {
                    let path = res.data.result;
                    let link = document.createElement("a");
                    link.href = path;
                    link.target = "_blank";
                    link.download = path.split("/").pop();
                    link.click();
                  } else {
                    this.$Message.warning(res.message);
                  }
                })

            }
          })
      }
    },
    formatterType(v) {
      let text = '';
      switch (Number(v)) {
        case 1:
          text = '一级半成品';
          break;
        case 2:
          text = '二级半成品';
          break;
        case 3:
          text = '成品';
          break;
      }
      return text
    },
    //打印
    printFhBtn(type) {
      let params = [];
      let arr = [];
      let pdfName = ''
      if (type == 1) {
        const selectedFhData = this.$refs.fhRef.getSelection();
        //  console.log(selectedFhData)
        arr = [].concat(selectedFhData)
        pdfName = '一级半成品复合'
      } else if (type == 2) {
        // arr = [].concat(this.partNoDetail.tagList)
        const selectedFgData = this.$refs.fgRef.getSelection();
        //  console.log(selectedFhData)
        arr = [].concat(selectedFgData)
        pdfName = '一级半成品分割'
      } else if (type == 3) {
        arr = [].concat(this.produceData)
        pdfName = '成品裁切'
      }
      if (arr.length == 0) {
        this.$Message.warning('请选择需要打印的列表！');
        return;
      }


      arr.forEach(item => {
        params.push({
          name: item.productName,
          code: item.goodsNo + "(" + this.timeFormate() + ")",
          type: this.formatterType(item.goodsType),
          width: item.productWidth,
          length: item.productLength / 1000,
          areaNum: Number(item.productWidth / 1000000 * item.productLength * item.num).toFixed(2),
          carat: item.num
        })
      })

      console.log(params)
      printPdf(params)
        .then(res => {
          if (res.code == 200) {
            let path = res.data.result;
            let link = document.createElement("a");
            link.href = path;
            link.target = "_blank";
            link.download = path.split("/").pop();
            link.click();
          } else {
            this.$Message.warning(res.message);
          }
        })
    },
    printOnePdf(param) {
      let arr = [{
        name: param.productName,
        code: param.goodsNo + "(" + this.timeFormate() + ")",
        type: this.formatterType(param.goodsType),
        width: param.productWidth,
        length: param.remainLength,
        areaNum: Number(param.productWidth / 1000 * param.productLength * param.num).toFixed(2),
        carat: param.num
      }];

      printPdf(arr)
        .then(res => {
          if (res.code == 200) {
            let path = res.data.result;
            let link = document.createElement("a");
            link.href = path;
            link.target = "_blank";
            link.download = path.split("/").pop();
            link.click();
          } else {
            this.$Message.warning(res.message);
          }
        })

    },
    timeFormate() {
      var timeStamp = new Date();
      let year = new Date(timeStamp).getFullYear();
      let month = new Date(timeStamp).getMonth() + 1 < 10 ? "0" + (new Date(timeStamp).getMonth() + 1) : new Date(
        timeStamp).getMonth() + 1;
      let date = new Date(timeStamp).getDate() < 10 ? "0" + new Date(timeStamp).getDate() : new Date(timeStamp)
        .getDate();
      return year + "-" + month + "-" + date;
    },
    finishPackBtn() {
      const data = this.$refs.DdbPackRefss.getSelection();
      if (data.length === 0) {
        this.$Message.warning('请勾选数据！');
        return
      }
      data.map( item => {
        item.parentId = this.packAgeObj.id
      })
      if(this.packAgeObj.unit == '卷'){
      addPackage(data)
        .then(res => {
          if (res.code == 200) {
            this.$Message.success('打包完成！');
            this.searchBtnPackAge()
            this.packModalFlag = false
          }
        })
      }else{
        let params = {
          packageV2s:data,
          packageNo:this.paperNumber,
        }
        addPack(params).then( res => {
          if (res.code == 200) {
            this.$Message.success('打包完成！');
            this.searchBtnPackAge()
            this.packModalFlag = false
          }
        })
      }
    },
    // savePack() {
    //   let params = {
    //     ...this.packForm
    //   }
    //   params.orderNo = this.partNoDetail.orderNo;
    //   savePackage(params)
    //     .then(res => {
    //       if (res.code == 200) {
    //         this.packForm = {}
    //         this.$Message.success('打包成功！');
    //         this.queryPackList()
    //       }
    //     })
    // },
    // saveFGPack() {
    //   const list = this.$refs.fgpackRef.getSelection();
    //   if (list.length == 0) {
    //     this.$Message.warning('请选择需要打包的产品！');
    //     return;
    //   }
    //   let params = {
    //     orderNo: this.partNoDetail.orderNo,
    //     perNum: this.packForm.perNum,
    //     list: list
    //   }
    //   console.log(params)
    //   // params.orderNo = this.partNoDetail.orderNo;
    //   saveCqPackage(params)
    //     .then(res => {
    //       if (res.code == 200) {
    //         this.packForm = {}
    //         this.$Message.success('打包成功！');
    //         this.getOneDetail()
    //       }
    //     })
    // },
    savePack() {
      let data = this.$refs.cqRef.getSelection();
      const type = this.selectedObj.type;
      let orderNo = this.partNoDetail.orderNo;
      if (type == 3) { //分割
        data = this.$refs.fgRef.getSelection();
        orderNo = this.packForm.orderNo
      } else if (type == 4) { //裁切
        data = this.$refs.cqRef.getSelection();
      } else { //工序打包
        data = this.$refs.DdbPackRef.getSelection();
      }

      if (data.length == 0) {
        this.$Message.warning('请选择需要打包的产品！');
        return;
      } else if (!orderNo) {
        this.$Message.warning('请选择需要打包的订单号！');
        return;
      }
      let params = {
        orderNo: orderNo,
        perNum: this.packForm.perNum,
        type: type,
        list: data
      }
      //  console.log(params)
      // params.orderNo = this.partNoDetail.orderNo;
      saveProductPackage(params)
        .then(res => {
          if (res.code == 200) {
            this.packForm = {}
            this.$Message.success('打包成功！');
            this.getOneDetail()
          }
        })
    },
    changeFgPackCustomer(e) { //切换客户分割打包
      this.queryPackList(this.packForm.orderNo);
    },
    //saveCqPackage
    queryPackList(orderNo) {
      if (!orderNo && !this.selectedObj.orderNo) {
        return;

      }


      let params = {
        orderNo: orderNo ? orderNo : this.selectedObj.orderNo.split(",")[0],
      }
      getPackageList(params)
        .then(res => {
          if (res.code == 200) {
            this.packData = [].concat(res.data);
          }
        })
    },
    getNumCount() {
      getOptNo().then(res => {
        if (res.code == 200) {
          this.numCountObj = res.data
        }
      })
    },
    selectWay(v) {
      if (v == 1) {
        this.timeNum = 180;
      } else {
        this.timeNum = 300;
      }
      clearInterval(this.intervalTime)
      this.countDown()
    },
    countDown() {
      // 设置倒计时
      this.intervalTime = setInterval(() => {
        if (this.timeNum == 0) {
          // this.getEquipList('1')
          this.getNumCount()
          // 重置倒计时状态
          // if (this.refreshWay == 1) {
          //   this.timeNum = 180;
          // } else {
          this.timeNum = 300;
          // }
        }
        // 倒计时
        this.timeNum--;
      }, 1000);
    },
    saveLength(v) {
      let params = {
        id: v.id,
        remainLength: v.remainLength
      }
      modyRemainCqLength(params)
        .then(res => {
          if (res.code == 200) {

          }
        })
    },
    productListGet() {
      let params = {
        id: this.searchForm.processId
      }
      findProductTreeList(params).then(res => {
        if (res.code == 200) {
          // let data = res.data;
          // let arr = [];
          // let newArr = []
          // data.forEach(item => {
          //   newArr.push(item)
          //   if(item.children && item.children.length > 0) {
          //     arr.push(...item.children)
          //   }
          // })
          // arr.push(data)
          this.productList = [].concat(res.data);
          console.log(res.data);
        }

      })
    },
    //完成裁切
    finishSliceBtn() {
      let params = {
        partNo: this.partNoDetail.partNo
      }
      completeCqGoods(params)
        .then(res => {
          if (res.code == 200) {
            this.$Message.success('完成裁切成功！');
            this.sliceModalFlag = false;
          }
        })
    },
    selectionCQToPackAge(v) {

      const list = this.$refs.cqRef.getSelection();
      var num = 0;
      for (var i in list) {
        num += parseInt(list[i].num);
      }
      console.log(list)
      this.packForm.count = num;
    },
    changeCqPackageCount(row) {

    },
    saveSliceBtn() {
      let params = {
        ...this.produceForm
      }
      // console.log(params)
      params.partNo = this.partNoDetail.partNo;
      addCqGoods(params)
        .then(res => {
          if (res.code == 200) {
            this.$Message.success('保存成功！');
            //this.getFhTableList(4)
            this.getOneDetail()
          }
        })
    },
    selectSlicePro(v) {
      // console.log(v)
      if (v) {
        let obj = this.getInfoById2(this.sliceData, v);
        // console.log(obj)
        this.produceForm = {
          productWidth: obj.productWidth,
          productLength: obj.productLength,
          totalJoint: obj.joint,
          goodsNo: obj.goodsNo
        }
      }



      console.log(this.produceForm)
    },
    //纸类合计价格
    handleSummary({
      columns,
      data
    }) {
      const sums = {};
      columns.forEach((column, index) => {
        const key = column.key;
        if (index === 0) {
          sums[key] = {
            key,
            value: '小计'
          };
          return;
        }
        const values = data.map(item => Number(item[key]));
        if (!values.every(value => isNaN(value))) {
          const v = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[key] = {
            key,
            value: key === 'pbLength' ? v.toFixed(2) : ''
          };
        } else {
          sums[key] = {
            key,
            value: ''
          };
        }
      });

      return sums;
    },
    beforeFinisCut() {
      completeTip({
        partNo: this.selectedObj.partNo,
        type: 3
      })
        .then(res => {
          if (res.code == 200) {
            if (res.data == 1) {
              this.$Modal.confirm({
                title: "确认",
                content: res.message + "是否确认完成分割?",
                onOk: () => {
                  this.finishCutBtn();
                }
              });

            } else {
              this.finishCutBtn();
            }

          } else {
            this.$Message.warning(res.message);
          }
        })
    },
    //完成分割
    finishCutBtn() {
      //二次提醒
      let params = {
        partNo: this.selectedObj.partNo,
      }
      completeFgGoods(params)
        .then(res => {
          if (res.code == 200) {
            this.$Message.success('分割完成！');
            this.cutModalFlag = false;
            this.getEquipList('1')
          }
        })
    },
    printBtn() {

    },
    finishBtn() {
      //二次提醒111

      completeTip({
        partNo: this.partNoDetail.partNo,
        type: 1
      })
        .then(res => {
          if (res.code == 200) {
            if (res.data == 1) {
              this.$Modal.confirm({
                title: "确认",
                content: res.message + ",是否确认完成复合?",
                onOk: () => {
                  this.completeFhCraft();
                }
              });

            } else {
              this.completeFhCraft();
            }

          } else {
            this.$Message.warning(res.message);
          }
        })


    },
    completeFhCraft() {
      completeFhGoods({
        partNo: this.partNoDetail.partNo
      })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success('复合成功！');
            this.reuniteModalFlag = false;
            this.getEquipList('1')
          }
        })

    },


    addBtn(type) {
      let obj = ''
      if (type == 1) {
        //obj = JSON.parse(JSON.stringify(this.backPaperData[0]))
        this.backPaperData.push({
          type: 1,
          goodsName: '',
          productName: '',
          oriWeight: null,
          weightLoss: null,
          remainWeight: null,
          goodsNo: '',
          partNo: this.partNoDetail.partNo,
        })
        console.log(this.backPaperData)
      } else if (type == 2) {
        //obj = JSON.parse(JSON.stringify(this.facialData[0]))
        this.facialData.push({
          type: 2,
          goodsName: '',
          productName: '',
          oriWeight: null,
          weightLoss: null,
          remainWeight: null,
          goodsNo: '',
          partNo: this.partNoDetail.partNo
        })
      } else {
        //obj = JSON.parse(JSON.stringify(this.glueData[0]))
        this.glueData.push({
          type: 3,
          goodsName: '',
          productName: '',
          oriWeight: null,
          weightLoss: null,
          remainWeight: null,
          goodsNo: '',
          partNo: this.partNoDetail.partNo
        })
      }
    },
    saveRow(v) {
      let params = {
        ...v
      }
      console.log(v)
      if (!params.partNo) {
        params.partNo = this.partNoDetail.partNo
      }
      savePartGoodSource(params)
        .then(res => {
          if (res.code == 200) {
            this.getOneDetail();
            this.$Message.success('保存成功！');
          }
        })
    },
    exitBtn() {
      this.$router.push({
        name: "login"
      });
      window.sessionStorage.removeItem('userInfo')
    },
    selectName(v, index) {
      let arr = [].concat(this.backPaperGoodsNameData[v.goodsName])
      v.backPaperGoodsNoData = arr
      this.$set(this.backPaperData, index, v)
    },
    selectName2(v, index) {
      let arr = [].concat(this.facialGoodsNameData[v.goodsName])
      v.facialGoodsNoData = arr
      this.$set(this.facialData, index, v)
    },
    selectName3(v, index) {
      let arr = [].concat(this.glueGoodsNameData[v.goodsName])
      v.glueGoodsNoData = arr
      this.$set(this.glueData, index, v)
    },
    selectRow(v, index) {
      if (v.goodsNo) {
        let info = this.getInfoById(v.backPaperGoodsNoData, v.goodsNo);
        v.specification = info.specification;
        v.oriWeight = info.oriWeight;
        this.$set(this.backPaperData, index, v)
      }

    },
    selectRow2(v, index) {
      if (v.goodsNo) {
        let info = this.getInfoById(v.facialGoodsNoData, v.goodsNo);
        v.specification = info.specification;
        v.oriWeight = info.oriWeight;
        this.$set(this.facialData, index, v)
      }
    },
    selectRow3(v, index) {
      if (v.goodsNo) {
        let info = this.getInfoById(v.glueGoodsNoData, v.goodsNo);
        v.specification = info.specification;
        v.oriWeight = info.oriWeight;
        this.$set(this.glueData, index, v)
      }
    },
    getInfoById(data, id) {
      let obj = ''
      data.forEach(item => {
        if (item.goodsNo == id) {
          obj = item;
          return
        }
      })
      return obj
    },
    getInfoById2(data, id) {
      let obj = ''
      data.forEach(item => {
        if (item.id == id) {
          obj = item;
          return
        }
      })
      return obj
    },
    changeRow(v, index) {
      this.$set(this.backPaperData, index, v)
    },
    changeRow2(v, index) {
      this.$set(this.facialData, index, v)
    },
    changeRow3(v, index) {
      this.$set(this.glueData, index, v)
    },
    submitBtn() {
      let params = {
        ...this.fhForm
      }
      params.partNo = this.partNoDetail.partNo;
      if (!params.productWidth || !params.productLength || !params.joint) {
        this.$Message.warning('请填写完整数据！');
        return
      }
      addFhGoods(params)
        .then(res => {
          if (res.code == 200) {
            this.$Message.success('保存成功！');
            //  this.fhForm = {}
            this.getFhTableList(1)
          }
        })
    },
    getFhTableList(type) {
      let params = {
        partNo: this.partNoDetail.partNo,
        type: type
      }
      getFhGoods(params)
        .then(res => {
          if (res.code == 200) {
            if (type == 1) {
              this.fhData = res.data;
            } else if (type == 3) {
              this.cutData = res.data;
            } else {
              this.produceData = res.data;
            }
          }
        })
    },
    editRow(v) {
      console.log(v)
      this.selectedObj = v;
      if (v.type == 1) {
        this.reuniteModalFlag = true;
        this.fhForm = {}
      } else if (v.type == 3) {
        this.cutModalFlag = true
      } else if (v.type == 4) {
        this.sliceModalFlag = true
        this.produceForm = {};
        this.proId = ''
      } else if (v.type == 5) {
        this.packModalFlag = true;
        this.packForm = {}
        this.queryPackList()
      }

      this.getOneDetail()

    },
    //二级成品获取
    clearData() {
      this.saveAllFgRowList = [];
      this.packData = [];
    },

    
    getGlueDataNosList(id) {
      let params = {
        goodsType: id
      }
      getGoodsNoList(params)
        .then(res => {
          if (res.code == 200) {
            this.glueGoodsNoData = res.data;
            const {
              sourceMap
            } = this.partNoDetail;
            //this.backPaperData = sourceMap['2'];
            //this.facialData =  sourceMap['1'];
            this.glueData = sourceMap['3'];
          }
        })
    },
    getFacialDatasList(id) {
      let params = {
        goodsType: id
      }
      getGoodsNoList(params)
        .then(res => {
          if (res.code == 200) {
            this.facialGoodsNoData = res.data;

            const {
              sourceMap
            } = this.partNoDetail;
            //this.backPaperData = sourceMap['2'];
            this.facialData = sourceMap['2'];
            //this.glueData = sourceMap['3'];
          }
        })
    },
    getBackPaperNosList(id) {
      let params = {
        goodsType: id
      }
      getGoodsNoList(params)
        .then(res => {
          if (res.code == 200) {
            this.backPaperGoodsNoData = res.data;
            const {
              sourceMap
            } = this.partNoDetail;
            this.backPaperData = sourceMap['1'];
          }
        })
    },
    changeSelect(v) {
      this.activeEquip = v;
      this.searchBtn()
    },
    changeTab(v) {
      this.activeTab = v
      window.sessionStorage.setItem("activeTab", v);
      if (v == 1) {
        this.$refs.pb.searchData()
        this.$refs.pb.getProductList()
      } else if (v == 0) {
        this.getProcessaData()
        this.searchData()
        this.getProductList()
      } else if (v == 2) {
        this.getProcessaData()
        this.searchBtnSplit()
        this.getProductListFg()
        this.getCustomerListFun()
      } else if (v == 3) {
        this.getProcessaData()
        this.searchBtnSlice()
        this.getProductListCq()
        this.getCustomerListSliceFun()

      }else if (v == 4) {
        this.searchBtnPackAge()
        this.getProductListDb()

      }else {
        this.$refs.progress.searchBtn()
      }
    },

    searchBtn() {
      this.pageNum = 1
      this.searchData()
    },
    searchBtnSplit() {
      this.pageNumSplit = 1
      this.searchDataSplit()
    },
    searchBtnSlice() {
      this.pageNumSlice = 1
      this.searchDataSlice()
    },
    searchBtnPackAge() {
      this.pageNumPackAge = 1
      this.searchDataPackAge()
    },
    searchDataPackAge() {
      this.tableDataPackAge = []
      let params = {
        data: {
          ...this.searchFormPackAge,
        },
        pageNum: this.pageNumPackAge,
        pageSize: this.pageSizePackAge,
      }
      this.loadingPackAge = true
      getPackageLists(params)
        .then(res => {
          this.loadingPackAge = false
          if (res.code == 200) {
            let data = res.data.records;
            this.tableDataPackAge = data
            this.totalPackAge = res.data.total
          }
        })
    },
    searchDataSlice() {
      this.tableDataSlice = []
      // this.processData.map(item => {
      //   if (this.searchFormSlice.processId == item.id) {
      //     this.searchFormSlice.machineName = item.name
      //   } else {
      //     this.searchFormSlice.machineName = null
      //   }
      // })
      let params = {
        data: {
          ...this.searchFormSlice,
        },
        pageNum: this.pageNumSlice,
        pageSize: this.pageSizeSlice,
      }
      this.loadingSlice = true
      getSlicePage(params)
        .then(res => {
          this.loadingSlice = false
          if (res.code == 200) {
            let data = res.data.records;
            // data.map( item => {
            //   let arrs = JSON.parse(item.spliteDetails)
            //   item.splitsOneLength = arrs.splitsOneLength
            // })
            // console.log("85222",data);
            this.tableDataSlice = data
            this.totalSlice = res.data.total
          }
        })
    },
    searchDataSplit() {
      this.tableDataSplit = []
      // this.processData.map(item => {
      //   if (this.searchFormSplit.processId == item.name) {
      //     this.searchFormSplit.machineName = item.name
      //   } else {
      //     this.searchFormSplit.machineName = null
      //   }
      // })
      let params = {
        data: {
          ...this.searchFormSplit,
        },
        pageNum: this.pageNumSplit,
        pageSize: this.pageSizeSplit,
      }
      this.loadingSplit = true
      getSplitsPage(params)
        .then(res => {
          this.loadingSplit = false
          if (res.code == 200) {
            let data = res.data.records;
            data.map( item => {
              let arrs = JSON.parse(item.spliteDetails)
              item.splitsOneLength = arrs.splitsOneLength
            })
            console.log("85222",data);
            this.tableDataSplit = data
            this.totalSplit = res.data.total
          }
        })
    },
    searchData() {
      this.tableData = []
      // this.processData.map(item => {
      //   if (this.searchForm.processId == item.id) {
      //     this.searchForm.machineName = item.name
      //     // delete this.searchForm.processId
      //   } else {
      //     this.searchForm.machineName = null
      //   }
      // })
      let params = {
        data: {
          ...this.searchForm,
        },
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }
      this.loading = true
      getCutPaperPasteList(params)
        .then(res => {
          this.loading = false
          if (res.code == 200) {
            this.tableData = res.data.records;
            this.total = res.data.total
            // this.tableData.forEach(item => {
            //   let arr = [];
            //   if (item.processList) {
            //     for (let i in item.processList) {
            //       arr.push({
            //         name: i,
            //         value: item.processList[i]
            //       })
            //     }
            //     item.processData = [].concat(arr)
            //   }

            // })
          }
        })
    },
    init() {
      let userInfo = window.sessionStorage.getItem('userInfo') ? JSON.parse(window.sessionStorage.getItem(
        'userInfo')) : '';
      this.activeTab = window.sessionStorage.getItem("activeTab")?window.sessionStorage.getItem("activeTab"):0;
      this.userName = userInfo.userName;
      // this.getProcessaData()
      if (this.activeTab == 1) {
        this.$refs.pb.searchData()
        this.$refs.pb.getProductList()
      } else if (this.activeTab == 0) {
        this.getProcessaData()
        this.searchData()
        this.getProductList()
      } else if (this.activeTab == 2) {
        this.getProcessaData()
        this.searchBtnSplit()
        this.getProductListFg()
        this.getCustomerListFun()
      } else if (this.activeTab == 3) {
        this.getProcessaData()
        this.searchBtnSlice()
        this.getProductListCq()
        this.getCustomerListSliceFun()
      }else if (this.activeTab == 4) {
        this.searchBtnPackAge()
        this.getProductListDb()

      }
      this.getNumCount()
      // this.productListGet()
      this.countDown()
    },
    getProcessaData() {
      // getProcessList()
      //   .then(res => {
      //     if (res.code == 200) {
      //       this.processData = res.data;
      //       this.searchForm.processId = res.data[0].id;
      //       this.getEquipList()
      //     }
      //   })
      let id = null
      if (this.activeTab == 0) {
        id = 20
      } else if (this.activeTab == 2) {
        id = 21
      } else if (this.activeTab == 3) {
        id = 22
      }
      getPage({
        data: {
          categoryId: id,
          makeFactoryId: 25,
          status: 0,
        },
        pageNum: 1,
        pageSize: 999,
      }).then(res => {
        if (res.code == 200) {
          this.processData = res.data.records;
        }
      })
    },
    getEquipList(type) {
      let params = {
        ...this.searchForm
      }
      getEquipList(params)
        .then(res => {
          if (res.code == 200) {
            this.equipData = [].concat(res.data);
            if (res.data && res.data.length > 0) {
              if (type == 1) {

              } else {
                this.activeEquip = res.data[0].equipId;
              }


            }
            this.searchBtn()
          }
        })
    },
    submitChangeEquip(v) { //提交需要切换的设备
      //this.equipForm
      changeEquip(this.equipForm)
        .then(res => {
          this.changeEquipFlag = false;
          // this.getEquipList();
          this.searchBtn();
        })
    },
    calExpectNum(v) { //计算预期数量
      //计算当前已经完成的数量
      console.log(this.produceData)
      var completeNum = 0;
      for (var i in this.produceData) {
        completeNum += this.produceData[i].initNum;
      }
      this.produceForm.num = this.produceForm.sum - completeNum;

      // if(!this.partNoDetail || ! this.partNoDetail.count){
      //  return;
      //  }
      //  var resultCount = this.partNoDetail.count- this.produceForm.sum;
      //  if(resultCount>this.produceForm.maxcount){
      //    resultCount = this.produceForm.maxcount;
      //  }
      //  this.produceForm.num = resultCount;
    }

  },
  mounted() {
    this.init()
  },
  destroyed() {
    console.log('666')
    clearInterval(this.intervalTime)
  },
  computed: {
    tableHeight() {
      return document.documentElement.clientHeight - 260;
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/index.vue